import { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";

// ─────────────────────────────────────────────────────────────────────────────
// CSS
// ─────────────────────────────────────────────────────────────────────────────
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,600;1,400&family=Jost:wght@300;400;500;600&display=swap');
*{box-sizing:border-box;margin:0;padding:0;}
html{scroll-behavior:smooth;}
body{font-family:'Jost',sans-serif;font-weight:300;background:#fafaf8;color:#1a1816;}
.df{font-family:'Cormorant Garamond',serif;}
.sl{font-size:10px;font-weight:500;letter-spacing:.2em;text-transform:uppercase;color:#c49535;font-family:'Jost',sans-serif;}
.btn-d{display:inline-flex;align-items:center;justify-content:center;gap:6px;background:#1a1816;color:#f5f0eb;padding:11px 22px;font-family:'Jost',sans-serif;font-size:11px;font-weight:500;letter-spacing:.12em;text-transform:uppercase;border:none;cursor:pointer;transition:background .18s;}
.btn-d:hover{background:#c49535;}
.btn-o{display:inline-flex;align-items:center;justify-content:center;background:transparent;color:#1a1816;padding:9px 18px;font-family:'Jost',sans-serif;font-size:11px;font-weight:500;letter-spacing:.12em;text-transform:uppercase;border:1px solid #c8c4c0;cursor:pointer;transition:all .18s;}
.btn-o:hover{background:#1a1816;color:#f5f0eb;border-color:#1a1816;}
.btn-danger{display:inline-flex;align-items:center;justify-content:center;background:#dc2626;color:#fff;padding:7px 14px;font-family:'Jost',sans-serif;font-size:11px;font-weight:500;border:none;cursor:pointer;transition:background .18s;border-radius:2px;}
.btn-danger:hover{background:#b91c1c;}
.inp{width:100%;border:1px solid #d4d0cc;background:#fff;padding:10px 12px;font-family:'Jost',sans-serif;font-size:13px;color:#1a1816;outline:none;transition:border-color .18s;}
.inp:focus{border-color:#c49535;}
.lbl{font-size:10px;letter-spacing:.1em;text-transform:uppercase;color:#79716c;font-family:'Jost',sans-serif;font-weight:500;display:block;margin-bottom:4px;}
.tab{padding:8px 16px;background:none;border:none;border-bottom:2px solid transparent;font-family:'Jost',sans-serif;font-size:12px;font-weight:500;letter-spacing:.1em;text-transform:uppercase;color:#79716c;cursor:pointer;transition:all .18s;}
.tab.active{border-bottom-color:#c49535;color:#1a1816;}
@keyframes spin{from{transform:rotate(0)}to{transform:rotate(360deg)}}
@keyframes fadeUp{from{opacity:0;transform:translateY(14px)}to{opacity:1;transform:translateY(0)}}
@keyframes zoomIn{from{opacity:0;transform:scale(.94)}to{opacity:1;transform:scale(1)}}
@keyframes fadeIn{from{opacity:0}to{opacity:1}}
.fu{animation:fadeUp .35s ease both;}
.zi{animation:zoomIn .22s ease both;}
.fi{animation:fadeIn .25s ease both;}
.cal-day{width:36px;height:36px;display:flex;align-items:center;justify-content:center;font-size:12px;font-family:'Jost',sans-serif;cursor:pointer;border-radius:2px;transition:all .15s;position:relative;}
.cal-day:hover:not(.cal-blocked):not(.cal-past){background:#f5f0eb;}
.cal-blocked{background:#fee2e2;color:#dc2626;cursor:not-allowed;text-decoration:line-through;}
.cal-past{color:#d4d0cc;cursor:not-allowed;}
.cal-in-range{background:#fef9c3;}
.cal-selected{background:#1a1816!important;color:#f5f0eb!important;border-radius:2px!important;}
.cal-today{font-weight:600;color:#c49535;}
.star{font-size:14px;cursor:pointer;transition:transform .1s;}
.star:hover{transform:scale(1.2);}
.ham-line{display:block;width:22px;height:2px;background:#1a1816;transition:all .25s;}
@media(max-width:700px){
  .prop-grid{grid-template-columns:1fr!important;}
  .detail-layout{display:flex!important;flex-direction:column!important;}
  .detail-main{order:2;}
  .detail-sidebar{order:1;}
  .gallery-main{grid-template-columns:1fr 1fr!important;grid-template-rows:165px 165px!important;height:333px!important;overflow:hidden!important;}
  .gallery-main>div:first-child{grid-row:1/3!important;grid-column:1/2!important;}
  .sub-ratings-grid{grid-template-columns:1fr 1fr!important;}
  .why-grid{grid-template-columns:1fr 1fr!important;}
  .book-form-grid{grid-template-columns:1fr!important;}
  .features-bar{gap:16px!important;justify-content:flex-start!important;overflow-x:auto!important;flex-wrap:nowrap!important;padding:12px 16px!important;-webkit-overflow-scrolling:touch;}
  .hero-btns{flex-direction:column!important;align-items:stretch!important;gap:10px!important;}
  .hero-btns a,.hero-btns button{width:100%!important;justify-content:center!important;}
  .detail-stats{gap:12px!important;}
  .detail-stats>div{min-width:60px;}
  .price-box{padding:16px!important;}
  .cal-day{width:32px!important;height:32px!important;font-size:11px!important;}
  .cal-wrap{overflow-x:auto;-webkit-overflow-scrolling:touch;}
  .review-header{flex-direction:column!important;align-items:flex-start!important;gap:12px!important;}
  .airbnb-link{width:100%!important;justify-content:center!important;}
  .btn-d,.btn-o{padding:12px 16px!important;font-size:11px!important;}
  .inp{font-size:16px!important;}
  .nav-text-link{display:none!important;}
  .nav-logo-text{display:none!important;}
  .lang-sel{padding:2px 4px!important;gap:2px!important;}
  .lang-sel button{font-size:15px!important;padding:1px 3px!important;}
  .nav-right{gap:8px!important;}
  .filter-btns{overflow-x:auto!important;-webkit-overflow-scrolling:touch;width:100%!important;flex-wrap:nowrap!important;padding-bottom:2px!important;}
  .filter-btns button{flex-shrink:0!important;}
  .main-wrap{overflow-x:hidden;}
}
`;

// ─────────────────────────────────────────────────────────────────────────────
// PLACEHOLDER SVG
// ─────────────────────────────────────────────────────────────────────────────
const PLACEHOLDER = "data:image/svg+xml," + encodeURIComponent(`
<svg xmlns="http://www.w3.org/2000/svg" width="800" height="500" viewBox="0 0 800 500">
  <rect width="800" height="500" fill="#f5f0eb"/>
  <rect x="330" y="180" width="140" height="100" rx="6" fill="#e8e2da"/>
  <circle cx="380" cy="215" r="18" fill="#c49535" opacity=".5"/>
  <polygon points="330,280 400,210 470,280" fill="#d4cec8"/>
  <rect x="350" y="245" width="40" height="35" rx="2" fill="#a09080"/>
  <text x="400" y="330" font-family="sans-serif" font-size="13" fill="#79716c" text-anchor="middle">Nessuna foto — carica dall'Admin</text>
  <text x="400" y="350" font-family="sans-serif" font-size="11" fill="#b0a898" text-anchor="middle">RelaxLuxuryStays • Agrigento, Sicilia</text>
</svg>`);

// ─────────────────────────────────────────────────────────────────────────────
// DEFAULT DATA
// ─────────────────────────────────────────────────────────────────────────────
function toSlug(title){
  return title.toLowerCase()
    .replace(/[àáâ]/g,'a').replace(/[èéê]/g,'e').replace(/[ìíî]/g,'i').replace(/[òóô]/g,'o').replace(/[ùúû]/g,'u')
    .replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');
}

const PROPS_DEFAULT = [
  { id:"3", airbnbId:"53087926", type:"APARTMENT",
    titleIt:"Relax Home Luxury City Rosemary", subtitleIt:"Appartamento di lusso nel centro di Agrigento",
    descIt:`Elegante appartamento di lusso situato nel cuore di Agrigento, a pochi passi dalle principali attrazioni turistiche e dal centro storico. L'appartamento è stato completamente ristrutturato con materiali di pregio e arredi di design.\n\nDispone di tutti i comfort: Wi-Fi ultra-veloce, smart TV, lavatrice, asciugatrice, ascensore e terrazza privata con vista sulla città.\n\nA piedi raggiungete facilmente ristoranti, bar, negozi e i principali monumenti. La Valle dei Templi dista solo 5 km.`,
    city:"Agrigento", region:"Sicilia", country:"Italia",
    price:85, cleaning:40, maxG:2, bed:1, beds:1, bath:1,
    ci:"15:00", co:"11:00", minN:2, priceRules:[],
    rules:["No fumo","No feste o eventi","Animali non ammessi","Max 2 ospiti"],
    rulesEn:["No smoking","No parties or events","No pets","Max 2 guests"],
    amenities:["wifi","kitchen","tv","elevator","washer","dryer","workspace","parking","terrace","ac"],
    airbnbRating:4.97, airbnbReviews:149,
    airbnbSubRatings:{pulizia:4.9,precisione:5.0,checkin:5.0,comunicazione:5.0,posizione:4.9,qualita:4.9},
    cover:"/images/rosemary/G4S_6153.jpg", images:["/images/rosemary/G4S_6153.jpg","/images/rosemary/G4S_6120-HDR.jpg","/images/rosemary/G4S_6126.jpg","/images/rosemary/G4S_6129-HDR.jpg","/images/rosemary/G4S_6136-HDR.jpg","/images/rosemary/G4S_6139.jpg","/images/rosemary/G4S_6143.jpg","/images/rosemary/G4S_6146.jpg","/images/rosemary/G4S_6147.jpg","/images/rosemary/G4S_6150-HDR.jpg","/images/rosemary/G4S_6207.jpg","/images/rosemary/G4S_6209.jpg","/images/rosemary/G4S_6213.jpg"], airbnbUrl:"https://www.airbnb.it/rooms/53087926",
    titleEn:"Relax Home Luxury City Rosemary", subtitleEn:"Luxury apartment in the heart of Agrigento",
    descEn:`Elegant luxury apartment in the heart of Agrigento, steps from the main attractions and historic center. Fully renovated with premium materials and designer furnishings.\n\nEquipped with all modern comforts: ultra-fast Wi-Fi, Smart TV, washer, dryer, elevator and private terrace with city views.\n\nRestaurants, cafés, shops and the main monuments are within easy walking distance. The Valley of the Temples is just 5 km away.`,
    subtitleEs:"Apartamento de lujo en el corazón de Agrigento",
    descEs:`Elegante apartamento de lujo en el corazón de Agrigento, a pocos pasos de las principales atracciones turísticas y del centro histórico. Completamente reformado con materiales de calidad y muebles de diseño.\n\nDispone de todas las comodidades: Wi-Fi ultra-rápido, Smart TV, lavadora, secadora, ascensor y terraza privada con vistas a la ciudad.\n\nA pie se llega fácilmente a restaurantes, bares, tiendas y los principales monumentos. El Valle de los Templos está a solo 5 km.`,
    rulesEs:["No fumar","No fiestas ni eventos","No se admiten mascotas","Máx. 2 huéspedes"],
    subtitleFr:"Appartement de luxe au cœur d'Agrigente",
    descFr:`Élégant appartement de luxe au cœur d'Agrigente, à quelques pas des principales attractions touristiques et du centre historique. Entièrement rénové avec des matériaux de qualité et un mobilier design.\n\nÉquipé de tout le confort : Wi-Fi ultra-rapide, Smart TV, lave-linge, sèche-linge, ascenseur et terrasse privée avec vue sur la ville.\n\nRestaurants, cafés, boutiques et les principaux monuments sont accessibles à pied. La Vallée des Temples est à seulement 5 km.`,
    rulesFr:["Non-fumeur","Pas de fêtes ni d'événements","Animaux non admis","Max. 2 voyageurs"],
    lat:37.3107, lng:13.5863 },
  { id:"4", airbnbId:"558876550358799583", type:"APARTMENT",
    titleIt:"Relax Home Luxury City Sage", subtitleIt:"Boutique apartment nel centro storico",
    descIt:`Scoprite il nostro esclusivo appartamento boutique "Sage" situato nel centro storico di Agrigento. Un gioiello di design e comfort, recentemente ristrutturato con cura artigianale e attenzione ai dettagli.\n\nL'appartamento offre un'esperienza unica: arredi selezionati, biancheria di qualità, cucina completamente attrezzata, Smart TV e connessione Wi-Fi ad alta velocità. L'ascensore garantisce accessibilità totale.\n\nPerfetto per chi cerca un soggiorno raffinato a due passi dalla storia: la Valle dei Templi e i migliori ristoranti di Agrigento sono facilmente raggiungibili.`,
    city:"Agrigento", region:"Sicilia", country:"Italia",
    price:85, cleaning:40, maxG:2, bed:1, beds:1, bath:1,
    ci:"15:00", co:"11:00", minN:2, priceRules:[],
    rules:["No fumo","No feste o eventi","Animali non ammessi","Max 2 ospiti"],
    rulesEn:["No smoking","No parties or events","No pets","Max 2 guests"],
    amenities:["wifi","kitchen","tv","elevator","washer","dryer","workspace","parking","terrace","ac"],
    airbnbRating:5.0, airbnbReviews:64,
    airbnbSubRatings:{pulizia:4.9,precisione:5.0,checkin:5.0,comunicazione:5.0,posizione:4.9,qualita:5.0},
    cover:"/images/sage/G4S_6160-HDR.jpg", images:["/images/sage/G4S_6160-HDR.jpg","/images/sage/G4S_6170-HDR.jpg","/images/sage/G4S_6164.jpg","/images/sage/G4S_6165.jpg","/images/sage/G4S_6166.jpg","/images/sage/G4S_6167.jpg","/images/sage/G4S_6168.jpg","/images/sage/G4S_6173.jpg","/images/sage/G4S_6175.jpg","/images/sage/G4S_6185.jpg","/images/sage/G4S_6191.jpg","/images/sage/G4S_6192.jpg","/images/sage/G4S_6193.jpg","/images/sage/G4S_6201.jpg","/images/sage/G4S_6204.jpg"], airbnbUrl:"https://www.airbnb.it/rooms/558876550358799583",
    titleEn:"Relax Home Luxury City Sage", subtitleEn:"Boutique apartment in the historic center",
    descEn:`Discover our exclusive boutique apartment "Sage" located in the historic center of Agrigento. A jewel of design and comfort, recently renovated with artisanal care and attention to detail.\n\nThe apartment offers a unique experience: curated furnishings, quality linens, fully equipped kitchen, Smart TV and high-speed Wi-Fi. The elevator ensures full accessibility.\n\nPerfect for a refined stay steps from history: the Valley of the Temples and Agrigento's best restaurants are easily reachable.`,
    subtitleEs:"Boutique apartment en el centro histórico",
    descEs:`Descubra nuestro exclusivo apartamento boutique "Sage" ubicado en el centro histórico de Agrigento. Una joya de diseño y confort, recientemente renovado con cuidado artesanal y atención al detalle.\n\nEl apartamento ofrece una experiencia única: mobiliario selecto, ropa de cama de calidad, cocina totalmente equipada, Smart TV y Wi-Fi de alta velocidad. El ascensor garantiza total accesibilidad.\n\nPerfecto para una estancia refinada a dos pasos de la historia: el Valle de los Templos y los mejores restaurantes de Agrigento son fácilmente accesibles.`,
    rulesEs:["No fumar","No fiestas ni eventos","No se admiten mascotas","Máx. 2 huéspedes"],
    subtitleFr:"Boutique apartment dans le centre historique",
    descFr:`Découvrez notre exclusif appartement boutique "Sage" situé dans le centre historique d'Agrigente. Un bijou de design et de confort, récemment rénové avec soin et attention aux détails.\n\nL'appartement offre une expérience unique : mobilier soigné, literie de qualité, cuisine entièrement équipée, Smart TV et Wi-Fi haut débit. L'ascenseur garantit une accessibilité totale.\n\nParfait pour un séjour raffiné à deux pas de l'histoire : la Vallée des Temples et les meilleurs restaurants d'Agrigente sont facilement accessibles.`,
    rulesFr:["Non-fumeur","Pas de fêtes ni d'événements","Animaux non admis","Max. 2 voyageurs"],
    lat:37.3107, lng:13.5863 },
  { id:"1", airbnbId:"2884204", type:"HOUSE",
    titleIt:"Relax Home Scala dei Turchi", subtitleIt:"Villa con vista mare a Scala dei Turchi",
    descIt:`Benvenuti nella nostra Relax Home a Scala dei Turchi, uno dei luoghi più iconici della Sicilia! La struttura si trova a pochi minuti a piedi dalla famosa scogliera bianca di Scala dei Turchi e dalla spiaggia di Punta Grande.\n\nLa casa è completamente arredata con ogni comfort: cucina attrezzata, connessione Wi-Fi, aria condizionata e parcheggio privato. Perfetta per famiglie o gruppi fino a 5 persone.\n\nGoditi il tramonto sulla terrazza con una vista mozzafiato sul Mar Mediterraneo. A soli 15 km da Agrigento e dalla famosa Valle dei Templi, patrimonio UNESCO.`,
    city:"Scala dei Turchi", region:"Sicilia", country:"Italia",
    price:90, cleaning:50, maxG:5, bed:2, beds:4, bath:1,
    ci:"15:00", co:"11:00", minN:2, priceRules:[],
    rules:["No fumo in casa","No feste o eventi","Animali non ammessi","Silenzio dopo le 22:00"],
    rulesEn:["No smoking indoors","No parties or events","No pets","Quiet after 10pm"],
    amenities:["wifi","kitchen","parking","tv","sea_view","hairdryer","fridge","workspace","ac"],
    airbnbRating:4.62, airbnbReviews:13,
    airbnbSubRatings:{pulizia:4.5,precisione:4.6,checkin:4.8,comunicazione:4.9,posizione:4.5,qualita:4.7},
    cover:"/images/scala-dei-turchi/IMG_7128.JPG",
    images:["/images/scala-dei-turchi/IMG_7129.JPG","/images/scala-dei-turchi/IMG_7130.JPG","/images/scala-dei-turchi/IMG_7131.JPG","/images/scala-dei-turchi/IMG_7132.JPG","/images/scala-dei-turchi/IMG_7133.JPG","/images/scala-dei-turchi/IMG_7134.JPG","/images/scala-dei-turchi/IMG_7135.JPG","/images/scala-dei-turchi/IMG_7136.JPG","/images/scala-dei-turchi/IMG_7137.JPG","/images/scala-dei-turchi/IMG_7138.JPG","/images/scala-dei-turchi/IMG_7139.JPG"],
    airbnbUrl:"https://www.airbnb.it/rooms/2884204",
    titleEn:"Relax Home Scala dei Turchi", subtitleEn:"Sea-view villa at Scala dei Turchi",
    descEn:`Welcome to our Relax Home at Scala dei Turchi, one of Sicily's most iconic locations! The property is a few minutes' walk from the famous white cliff of Scala dei Turchi and Punta Grande beach.\n\nFully furnished with every comfort: equipped kitchen, Wi-Fi, air conditioning and private parking. Perfect for families or groups of up to 5 people.\n\nEnjoy the sunset from the terrace with a breathtaking view of the Mediterranean Sea. Just 15 km from Agrigento and the Valley of the Temples, a UNESCO World Heritage site.`,
    subtitleEs:"Villa con vistas al mar en Scala dei Turchi",
    descEs:`¡Bienvenidos a nuestra Relax Home en Scala dei Turchi, uno de los lugares más icónicos de Sicilia! La propiedad se encuentra a pocos minutos a pie del famoso acantilado blanco de Scala dei Turchi y de la playa de Punta Grande.\n\nCompletamente amueblada con todas las comodidades: cocina equipada, Wi-Fi, aire acondicionado y aparcamiento privado. Perfecta para familias o grupos de hasta 5 personas.\n\nDisfrute del atardecer desde la terraza con una impresionante vista del Mar Mediterráneo. A solo 15 km de Agrigento y del Valle de los Templos, Patrimonio de la Humanidad UNESCO.`,
    rulesEs:["No fumar en el interior","No fiestas ni eventos","No se admiten mascotas","Silencio después de las 22:00"],
    subtitleFr:"Villa avec vue mer à Scala dei Turchi",
    descFr:`Bienvenue dans notre Relax Home à Scala dei Turchi, l'un des endroits les plus emblématiques de la Sicile ! La propriété se trouve à quelques minutes à pied de la célèbre falaise blanche de Scala dei Turchi et de la plage de Punta Grande.\n\nEntièrement meublée avec tout le confort : cuisine équipée, Wi-Fi, climatisation et parking privé. Parfaite pour les familles ou groupes jusqu'à 5 personnes.\n\nProfitez du coucher de soleil depuis la terrasse avec une vue imprenable sur la Méditerranée. À seulement 15 km d'Agrigente et de la Vallée des Temples, classée au patrimoine UNESCO.`,
    rulesFr:["Non-fumeur à l'intérieur","Pas de fêtes ni d'événements","Animaux non admis","Silence après 22h00"],
    lat:37.2742, lng:13.4574 },
  { id:"2", airbnbId:"5081130", type:"VILLA",
    titleIt:"Casa Relax in Campagna", subtitleIt:"Villa con piscina privata e giardino",
    descIt:`Immergetevi nella tranquillità della campagna agrigentina con questa splendida villa con piscina privata! La proprietà si trova in posizione strategica: a soli 10 minuti dalla Valle dei Templi (patrimonio UNESCO) e dal centro di Agrigento.\n\nLa villa dispone di ampio giardino, piscina privata, zona barbecue e tutti i comfort moderni. Ideale per coppie o famiglie che cercano relax assoluto lontano dal caos.\n\nPotrete ammirare uno splendido panorama sulla Valle dei Templi direttamente dalla piscina.`,
    city:"Agrigento", region:"Sicilia", country:"Italia",
    price:130, cleaning:60, maxG:3, bed:1, beds:1, bath:1,
    ci:"15:00", co:"10:00", minN:2, priceRules:[],
    rules:["No fumo in casa","No feste o eventi","Animali ammessi con accordo","Rispettare il giardino"],
    rulesEn:["No smoking indoors","No parties or events","Pets allowed by agreement","Please respect the garden"],
    amenities:["wifi","pool","kitchen","parking","bbq","garden","workspace","valley_view","ac"],
    airbnbRating:4.68, airbnbReviews:160,
    airbnbSubRatings:{pulizia:4.2,precisione:4.8,checkin:4.9,comunicazione:4.9,posizione:4.6,qualita:4.8},
    cover:"/images/casa-in-campagna/campagna-1.jpg", images:["/images/casa-in-campagna/campagna-1.jpg","/images/casa-in-campagna/campagna-2.jpg","/images/casa-in-campagna/campagna-3.jpg","/images/casa-in-campagna/campagna-4.jpg","/images/casa-in-campagna/campagna-5.jpg","/images/casa-in-campagna/campagna-6.jpg","/images/casa-in-campagna/campagna-7.jpg","/images/casa-in-campagna/campagna-8.jpg","/images/casa-in-campagna/campagna-9.jpg","/images/casa-in-campagna/campagna-10.jpg"], airbnbUrl:"https://www.airbnb.it/rooms/5081130",
    titleEn:"Casa Relax in Campagna", subtitleEn:"Private pool villa with garden",
    descEn:`Immerse yourself in the tranquility of the Agrigento countryside with this stunning villa featuring a private pool! Strategically located just 10 minutes from the Valley of the Temples (UNESCO) and Agrigento city center.\n\nThe villa features a large garden, private pool, barbecue area and all modern comforts. Ideal for couples or families seeking total relaxation away from the hustle.\n\nEnjoy a spectacular panoramic view of the Valley of the Temples directly from the pool.`,
    subtitleEs:"Villa con piscina privada y jardín",
    descEs:`¡Sumérgete en la tranquilidad del campo de Agrigento con esta espléndida villa con piscina privada! La propiedad está estratégicamente situada a solo 10 minutos del Valle de los Templos (Patrimonio UNESCO) y del centro de Agrigento.\n\nLa villa dispone de amplio jardín, piscina privada, zona de barbacoa y todas las comodidades modernas. Ideal para parejas o familias que buscan un relax total lejos del bullicio.\n\nPodrá admirar un espectacular panorama sobre el Valle de los Templos directamente desde la piscina.`,
    rulesEs:["No fumar en el interior","No fiestas ni eventos","Mascotas admitidas con acuerdo","Por favor respete el jardín"],
    subtitleFr:"Villa avec piscine privée et jardin",
    descFr:`Plongez dans la tranquillité de la campagne d'Agrigente avec cette splendide villa avec piscine privée ! La propriété est stratégiquement située à seulement 10 minutes de la Vallée des Temples (patrimoine UNESCO) et du centre d'Agrigente.\n\nLa villa dispose d'un grand jardin, d'une piscine privée, d'un espace barbecue et de tous les équipements modernes. Idéale pour les couples ou familles en quête d'un vrai repos loin de l'agitation.\n\nVous pourrez admirer un spectaculaire panorama sur la Vallée des Temples directement depuis la piscine.`,
    rulesFr:["Non-fumeur à l'intérieur","Pas de fêtes ni d'événements","Animaux admis avec accord","Veuillez respecter le jardin"],
    lat:37.2905, lng:13.5812 },
];

const REVIEWS_DEFAULT = {
  "1":[
    {id:"r1a",name:"Daniele",country:"🌍",date:"Agosto 2025",location:"7 anni su Airbnb",rating:4,approved:true,
      text:"Se cerchi un posto dove rilassarti e goderti davvero il mare, questa casa è perfetta 🏖️✨. Si trova in una posizione comodissima, a due passi dalla spiaggia, ed è l'ideale sia per famiglie che per coppie.",
      textEn:"If you're looking for a place to truly relax and enjoy the sea, this house is perfect 🏖️✨. It's in a very convenient location, steps from the beach, and ideal for both families and couples.",
      textEs:"Si buscas un lugar donde relajarte y disfrutar del mar de verdad, esta casa es perfecta 🏖️✨. Se encuentra en una ubicación muy cómoda, a dos pasos de la playa, y es ideal tanto para familias como para parejas.",
      textFr:"Si vous cherchez un endroit où vous détendre et profiter de la mer, cette maison est parfaite 🏖️✨. Elle est très bien située, à deux pas de la plage, et idéale pour les familles comme pour les couples."},
    {id:"r1b",name:"Paola",country:"🌍",date:"Aprile 2025",location:"4 anni su Airbnb",rating:4,approved:true,
      text:"La posizione dell'appartamento è molto buona. A 1 minuto a piedi da una bellissima spiaggia sabbiosa e a 10 minuti a piedi dalla Scala dei Turchi.",
      textEn:"The apartment's location is very good. 1 minute walk from a beautiful sandy beach and 10 minutes walk from Scala dei Turchi.",
      textEs:"La ubicación del apartamento es muy buena. A 1 minuto a pie de una preciosa playa de arena y a 10 minutos a pie de Scala dei Turchi.",
      textFr:"L'emplacement de l'appartement est très bon. À 1 minute à pied d'une belle plage de sable et à 10 minutes à pied de Scala dei Turchi."},
    {id:"r1c",name:"Sebastiano",country:"🌍",date:"Agosto 2016",location:"10 anni su Airbnb",rating:5,approved:true,
      text:"Che dire, tutto fantastico. Per un problema tecnico ci hanno dato la casa sopra invece di questa, che è uguale (forse c'è una stanza in più da noi non utilizzata, e un terrazzo vista mare). Posto meraviglioso.",
      textEn:"What can I say, everything was fantastic. Due to a technical issue they gave us the apartment above instead, which is the same (perhaps with an extra room we didn't use, and a sea-view terrace). Wonderful place.",
      textEs:"¿Qué decir, todo fantástico. Por un problema técnico nos dieron la casa de arriba en lugar de esta, que es igual (quizás con una habitación extra que no usamos, y una terraza con vista al mar). Lugar maravilloso.",
      textFr:"Que dire, tout était fantastique. En raison d'un problème technique, on nous a donné la maison du dessus à la place, qui est identique (peut-être avec une chambre supplémentaire et une terrasse vue mer). Endroit merveilleux."},
    {id:"r1d",name:"Ivano",country:"🌍",date:"Luglio 2016",location:"12 anni su Airbnb",rating:4,approved:true,
      text:"La casa del Sig. Vittorio è molto comoda per una vacanza in pieno relax ideale per una famiglia come la nostra. La spiaggia è vicinissima e la Scala dei Turchi a 15 min, spettacolare il posto.",
      textEn:"Mr. Vittorio's house is very comfortable for a fully relaxing holiday, ideal for a family like ours. The beach is very close and Scala dei Turchi is 15 min away — a spectacular place.",
      textEs:"La casa del Sr. Vittorio es muy cómoda para unas vacaciones de relax total, ideal para una familia como la nuestra. La playa está muy cerca y Scala dei Turchi a 15 min, el lugar es espectacular.",
      textFr:"La maison de M. Vittorio est très confortable pour des vacances en pleine détente, idéale pour une famille comme la nôtre. La plage est très proche et Scala dei Turchi à 15 min, l'endroit est spectaculaire."},
    {id:"r1e",name:"Marianna",country:"🇨🇭",date:"Giugno 2016",location:"Lugano, Svizzera",rating:4,approved:true,
      text:"La casa è molto bella, dotata di tutto il necessario per una vacanza davvero relax. Si trova a 40 metri dalla spiaggia e 20 minuti a piedi dalla Scala dei Turchi. Il Sig Vittorio e suo nipote sono stati gentilissimi.",
      textEn:"The house is very beautiful, equipped with everything needed for a truly relaxing holiday. It is 40 metres from the beach and 20 minutes walk from Scala dei Turchi. Mr Vittorio and his nephew were very kind.",
      textEs:"La casa es muy bonita, equipada con todo lo necesario para unas vacaciones realmente relajantes. Está a 40 metros de la playa y a 20 minutos a pie de Scala dei Turchi. El Sr. Vittorio y su sobrino fueron muy amables.",
      textFr:"La maison est très belle, équipée de tout le nécessaire pour des vacances vraiment détendues. Elle se trouve à 40 mètres de la plage et à 20 minutes à pied de Scala dei Turchi. M. Vittorio et son neveu ont été très aimables."},
    {id:"r1f",name:"Francesca",country:"🌍",date:"Giugno 2016",location:"10 anni su Airbnb",rating:5,approved:true,
      text:"Ci ha accolto il nipote del sig. Vittorio che è stato gentilissimo e fin da subito molto disponibile a mostrarci la casa e a consigliarci sui dintorni. In più ci hanno offerto un bicchiere di vino al nostro arrivo!",
      textEn:"We were welcomed by Mr. Vittorio's nephew who was very kind and immediately helpful in showing us around the house and advising us on the surroundings. They even offered us a glass of wine on arrival!",
      textEs:"Nos recibió el sobrino del Sr. Vittorio, muy amable y desde el primer momento muy dispuesto a mostrarnos la casa y aconsejarnos sobre los alrededores. ¡Además nos ofrecieron una copa de vino a nuestra llegada!",
      textFr:"Nous avons été accueillis par le neveu de M. Vittorio, très aimable et dès le début très disponible pour nous montrer la maison et nous conseiller sur les environs. De plus, ils nous ont offert un verre de vin à notre arrivée !"},
  ],
  "2":[
    {id:"r2a",name:"Jesper",country:"🌍",date:"Luglio 2025",location:"9 anni su Airbnb",rating:5,approved:true,
      text:"La casa e il giardino/la posizione sono ancora meglio di quanto descritto. Il giardino è molto grande e privato. Vittorio è un ottimo host, ci ha accolto di persona e ci ha dato ottimi consigli per visitare la zona.",
      textEn:"The house, garden and location are even better than described. The garden is very large and private. Vittorio is an excellent host, he welcomed us in person and gave us great tips for visiting the area.",
      textEs:"La casa, el jardín y la ubicación son incluso mejores de lo descrito. El jardín es muy grande y privado. Vittorio es un excelente anfitrión, nos recibió en persona y nos dio excelentes consejos para visitar la zona.",
      textFr:"La maison, le jardin et l'emplacement sont encore mieux que décrits. Le jardin est très grand et privé. Vittorio est un excellent hôte, il nous a accueillis en personne et nous a donné d'excellents conseils pour visiter la région."},
    {id:"r2b",name:"Carmelina",country:"🌍",date:"Giugno 2025",location:"11 anni su Airbnb",rating:5,approved:true,
      text:"Siamo stati molto bene. Il padrone di casa è stato molto cordiale e ci ha accolto bene in casa. La zona è tranquilla ma centrale e tutti i luoghi sono facilmente raggiungibili.",
      textEn:"We had a great time. The host was very friendly and welcomed us warmly. The area is quiet but central and all places are easily reachable.",
      textEs:"Lo pasamos muy bien. El propietario fue muy cordial y nos recibió cálidamente. La zona es tranquila pero central y todos los lugares son fácilmente accesibles.",
      textFr:"Nous avons passé un excellent séjour. Le propriétaire a été très cordial et nous a bien accueillis. Le quartier est calme mais central et tous les endroits sont facilement accessibles."},
    {id:"r2c",name:"Sandra",country:"🌍",date:"Agosto 2025",location:"3 anni su Airbnb",rating:4,approved:true,
      text:"Il nostro soggiorno da Vittorio è stato fantastico! Ha sempre risposto rapidamente ai messaggi e ci ha dato istruzioni dettagliate per trovare l'alloggio. Siamo stati accolti in modo caloroso.",
      textEn:"Our stay with Vittorio was fantastic! He always responded quickly to messages and gave us detailed instructions to find the accommodation. We were welcomed very warmly.",
      textEs:"¡Nuestra estancia con Vittorio fue fantástica! Siempre respondió rápidamente a los mensajes y nos dio instrucciones detalladas para encontrar el alojamiento. Fuimos recibidos muy cálidamente.",
      textFr:"Notre séjour chez Vittorio était fantastique ! Il a toujours répondu rapidement aux messages et nous a donné des instructions détaillées pour trouver le logement. Nous avons été accueillis très chaleureusement."},
    {id:"r2d",name:"Amber",country:"🌍",date:"Ottobre 2024",location:"3 anni su Airbnb",rating:4,approved:true,
      text:"Posizione facile da raggiungere. Host molto gentile e reattivo. Mi è piaciuto molto il panorama! Piscina bella e pulita. Casa molto italiana :)",
      textEn:"Easy to reach location. Very kind and responsive host. I really loved the view! Beautiful and clean pool. Very Italian house :)",
      textEs:"Ubicación fácil de encontrar. Anfitrión muy amable y atento. ¡Me encantó el panorama! Piscina bonita y limpia. Casa muy italiana :)",
      textFr:"Emplacement facile d'accès. Hôte très gentil et réactif. J'ai adoré la vue panoramique ! Piscine belle et propre. Maison très italienne :)"},
    {id:"r2e",name:"Tony",country:"🌍",date:"Luglio 2024",location:"7 anni su Airbnb",rating:5,approved:true,
      text:"Abbiamo soggiornato per una settimana e ci siamo goduti ogni minuto. Per noi era perfetto, aveva tutto ciò di cui avevamo bisogno, era tranquillo e pieno di personalità. A 10 minuti dalla Valle dei Templi.",
      textEn:"We stayed for a week and enjoyed every minute. It was perfect for us, had everything we needed, was quiet and full of character. 10 minutes from the Valley of the Temples.",
      textEs:"Nos quedamos una semana y disfrutamos cada minuto. Para nosotros era perfecto, tenía todo lo que necesitábamos, era tranquilo y lleno de personalidad. A 10 minutos del Valle de los Templos.",
      textFr:"Nous avons séjourné une semaine et profité de chaque minute. C'était parfait pour nous, calme et plein de caractère, avec tout ce dont nous avions besoin. À 10 minutes de la Vallée des Temples."},
    {id:"r2f",name:"Simon",country:"🌍",date:"Settembre 2024",location:"4 anni su Airbnb",rating:5,approved:true,
      text:"Vittorio è stato un host formidabile. Ha fornito molti consigli per le attività vicino alla villa, di cui abbiamo fatto solo alcune perché abbiamo soggiornato la maggior parte del tempo nella piscina privata.",
      textEn:"Vittorio was a formidable host. He provided many suggestions for activities near the villa, of which we only did a few because we spent most of our time in the private pool.",
      textEs:"Vittorio fue un anfitrión formidable. Dio muchos consejos para actividades cerca de la villa, de los cuales solo hicimos algunos porque pasamos la mayor parte del tiempo en la piscina privada.",
      textFr:"Vittorio a été un hôte formidable. Il a fourni de nombreux conseils pour les activités près de la villa, dont nous n'avons fait que quelques-uns car nous avons passé la plupart du temps dans la piscine privée."},
  ],
  "3":[
    {id:"r3a",name:"Regina",country:"🇺🇸",date:"Gennaio 2026",location:"Portland, Oregon",rating:5,approved:true,
      text:"L'appartamento si trova in una posizione ottima, proprio accanto al centro storico. È privato, pulito e ben attrezzato. Vittorio ci ha accolto e ci ha dato ottimi consigli per visite ed escursioni nella zona.",
      textEn:"The apartment is in a great location, right next to the historic center. It is private, clean and well equipped. Vittorio welcomed us and gave us great tips for visits and excursions in the area.",
      textEs:"El apartamento está en una ubicación excelente, justo al lado del centro histórico. Es privado, limpio y bien equipado. Vittorio nos recibió y nos dio excelentes consejos para visitas y excursiones en la zona.",
      textFr:"L'appartement est idéalement situé, juste à côté du centre historique. Il est privé, propre et bien équipé. Vittorio nous a accueillis et nous a donné d'excellents conseils pour les visites et excursions dans la région."},
    {id:"r3b",name:"Monia",country:"🌍",date:"Marzo 2026",location:"4 anni su Airbnb",rating:5,approved:true,
      text:"Ci siamo trovati molto bene fin dal primo momento. L'appartamento era super pulito e di alta qualità. La comunicazione con Vittorio è stata semplicemente fantastica: disponibile, preciso e gentile.",
      textEn:"We felt at home from the very first moment. The apartment was super clean and of high quality. Communication with Vittorio was simply fantastic: helpful, precise and kind.",
      textEs:"Nos sentimos muy a gusto desde el primer momento. El apartamento estaba muy limpio y de alta calidad. La comunicación con Vittorio fue simplemente fantástica: disponible, preciso y amable.",
      textFr:"Nous nous sommes sentis très bien dès le premier moment. L'appartement était super propre et de haute qualité. La communication avec Vittorio était tout simplement fantastique : disponible, précis et gentil."},
    {id:"r3c",name:"Eduardo",country:"🇺🇸",date:"Ottobre 2025",location:"Washington, District of Columbia",rating:5,approved:true,
      text:"La casa di Vittorio è il posto dove soggiornare ad Agrigento. È moderno, ben attrezzato e perfettamente situato nel cuore della città. Lo stesso Vittorio è eccezionalmente attento e disponibile.",
      textEn:"Vittorio's place is the place to stay in Agrigento. It is modern, well-equipped and perfectly located in the heart of the city. Vittorio himself is exceptionally attentive and helpful.",
      textEs:"La casa de Vittorio es el lugar donde alojarse en Agrigento. Es moderna, bien equipada y perfectamente situada en el corazón de la ciudad. El propio Vittorio es excepcionalmente atento y disponible.",
      textFr:"La maison de Vittorio est l'endroit où séjourner à Agrigente. Elle est moderne, bien équipée et parfaitement située au cœur de la ville. Vittorio lui-même est exceptionnellement attentionné et disponible."},
    {id:"r3d",name:"Serene",country:"🌍",date:"Ottobre 2025",location:"10 anni su Airbnb",rating:5,approved:true,
      text:"Abbiamo trascorso un soggiorno incantevole ad Agrigento. Grazie per essere stati degli host così meravigliosi e reattivi. Siete dei padroni di casa davvero accoglienti, cordiali e disponibili.",
      textEn:"We had an enchanting stay in Agrigento. Thank you for being such wonderful and responsive hosts. You are truly welcoming, friendly and helpful.",
      textEs:"Pasamos una estancia encantadora en Agrigento. Gracias por ser unos anfitriones tan maravillosos y atentos. Sois unos propietarios realmente acogedores, cordiales y disponibles.",
      textFr:"Nous avons passé un séjour enchanteur à Agrigente. Merci d'avoir été des hôtes si merveilleux et réactifs. Vous êtes vraiment accueillants, chaleureux et disponibles."},
    {id:"r3e",name:"Michelle",country:"🇺🇸",date:"Ottobre 2025",location:"New York, Stato di New York",rating:5,approved:true,
      text:"L'appartamento è pulito, spazioso e splendidamente decorato. Ottima posizione, a pochi passi dal centro storico, dal negozio di alimentari e dai caffè. Breve tragitto in auto per raggiungere la Valle dei Templi.",
      textEn:"The apartment is clean, spacious and beautifully decorated. Great location, steps from the historic center, grocery store and cafés. Short drive to reach the Valley of the Temples.",
      textEs:"El apartamento está limpio, espacioso y bellamente decorado. Excelente ubicación, a pocos pasos del centro histórico, del supermercado y de las cafeterías. Corto trayecto en coche para llegar al Valle de los Templos.",
      textFr:"L'appartement est propre, spacieux et magnifiquement décoré. Excellente situation, à quelques pas du centre historique, de l'épicerie et des cafés. Court trajet en voiture pour atteindre la Vallée des Temples."},
    {id:"r3f",name:"Michaela Und Thomas",country:"🌍",date:"Marzo 2026",location:"10 anni su Airbnb",rating:5,approved:true,
      text:"L'appartamento di Vittorio è arredato con molto stile. Ci siamo sentiti subito a casa nostra. C'era tutto il necessario. Particolarmente degno di nota per noi del Nord Europa: c'era l'aria condizionata, fondamentale in estate.",
      textEn:"Vittorio's apartment is furnished with great style. We felt at home right away. Everything we needed was there. Particularly noteworthy for us from Northern Europe: there was air conditioning, essential in summer.",
      textEs:"El apartamento de Vittorio está decorado con mucho estilo. Nos sentimos en casa de inmediato. Había todo lo necesario. Especialmente destacable para nosotros del norte de Europa: había aire acondicionado, fundamental en verano.",
      textFr:"L'appartement de Vittorio est décoré avec beaucoup de style. Nous nous sommes sentis chez nous immédiatement. Il y avait tout le nécessaire. Particulièrement notable pour nous du nord de l'Europe : la climatisation, essentielle en été."},
  ],
  "4":[
    {id:"r4a",name:"Robert",country:"🇺🇸",date:"Ottobre 2025",location:"Wauwatosa, Wisconsin",rating:5,approved:true,
      text:"Host eccellente in un appartamento eccellente nel centro di Agrigento, a pochi passi dal suo centro storico. Siamo stati accolti di persona da Vittorio, che ha trascorso del tempo con noi mostrandoci l'appartamento e la zona.",
      textEn:"Excellent host in an excellent apartment in the center of Agrigento, steps from the historic center. We were personally welcomed by Vittorio, who spent time with us showing us the apartment and the neighborhood.",
      textEs:"Excelente anfitrión en un excelente apartamento en el centro de Agrigento, a pocos pasos del centro histórico. Fuimos recibidos en persona por Vittorio, quien pasó tiempo con nosotros mostrándonos el apartamento y el barrio.",
      textFr:"Excellent hôte dans un excellent appartement au centre d'Agrigente, à quelques pas du centre historique. Nous avons été personnellement accueillis par Vittorio, qui a passé du temps avec nous pour nous montrer l'appartement et le quartier."},
    {id:"r4b",name:"Gary",country:"🌍",date:"Ottobre 2025",location:"10 anni su Airbnb",rating:5,approved:true,
      text:"Wow! L'appartamento boutique immacolato è stato splendidamente progettato con molto moderno e confortevole e in una posizione molto sicura circondata da tutto ciò di cui avevamo bisogno.",
      textEn:"Wow! The immaculate boutique apartment was beautifully designed, very modern and comfortable, in a very safe location surrounded by everything we needed.",
      textEs:"¡Wow! El impecable apartamento boutique fue espléndidamente diseñado, muy moderno y cómodo, en una ubicación muy segura rodeada de todo lo que necesitábamos.",
      textFr:"Wow ! L'appartement boutique impeccable a été splendidement conçu, très moderne et confortable, dans un emplacement très sûr entouré de tout ce dont nous avions besoin."},
    {id:"r4c",name:"Sandro",country:"🌍",date:"Aprile 2025",location:"4 anni su Airbnb",rating:5,approved:true,
      text:"Agrigento Città vale la visita e interessante la Valle dei Templi.",
      textEn:"Agrigento city is worth visiting and the Valley of the Temples is fascinating.",
      textEs:"Agrigento merece la visita y el Valle de los Templos es muy interesante.",
      textFr:"Agrigente vaut le déplacement et la Vallée des Temples est très intéressante."},
    {id:"r4d",name:"Liliane",country:"🇨🇭",date:"Maggio 2024",location:"Berna, Svizzera",rating:5,approved:true,
      text:"Great stay in Agrigento! L'appartamento è molto ben posizionato, vicino a molti ristoranti e negozi. Ci è piaciuto molto lo spazio ben progettato. Consiglio vivamente questo alloggio.",
      textEn:"Great stay in Agrigento! The apartment is very well located, close to many restaurants and shops. We really enjoyed the well-designed space. I highly recommend this accommodation.",
      textEs:"¡Estancia genial en Agrigento! El apartamento está muy bien ubicado, cerca de muchos restaurantes y tiendas. Nos gustó mucho el espacio bien diseñado. Recomiendo encarecidamente este alojamiento.",
      textFr:"Super séjour à Agrigente ! L'appartement est très bien situé, près de nombreux restaurants et boutiques. Nous avons beaucoup aimé l'espace bien conçu. Je recommande vivement ce logement."},
    {id:"r4e",name:"Robin",country:"🌍",date:"Settembre 2025",location:"4 anni su Airbnb",rating:5,approved:true,
      text:"Abbiamo avuto la possibilità di concordare un check-in anticipato. Anche i parcheggi sono molto ben attrezzati. Vittorio ci ha accolto in modo super cordiale e ci ha mostrato tutto quello che c'era da sapere.",
      textEn:"We were able to arrange an early check-in. The parking is also very well equipped. Vittorio welcomed us in a super friendly way and showed us everything there was to know.",
      textEs:"Tuvimos la posibilidad de acordar un check-in anticipado. El aparcamiento también está muy bien equipado. Vittorio nos acogió de manera muy cordial y nos mostró todo lo que había que saber.",
      textFr:"Nous avons pu convenir d'un check-in anticipé. Le parking est également très bien équipé. Vittorio nous a accueillis de manière super cordiale et nous a montré tout ce qu'il y avait à savoir."},
    {id:"r4f",name:"Ecem",country:"🌍",date:"Agosto 2025",location:"10 mesi su Airbnb",rating:5,approved:true,
      text:"Il soggiorno è stato molto piacevole. L'appartamento era molto pulito e corrispondeva alle foto. Tutto molto curato e arredato in modo confortevole. Nei dintorni ci sono ottimi ristoranti e negozi.",
      textEn:"The stay was very enjoyable. The apartment was very clean and matched the photos. Everything was very well maintained and comfortably furnished. There are excellent restaurants and shops nearby.",
      textEs:"La estancia fue muy agradable. El apartamento estaba muy limpio y correspondía con las fotos. Todo muy cuidado y decorado de forma cómoda. En los alrededores hay excelentes restaurantes y tiendas.",
      textFr:"Le séjour a été très agréable. L'appartement était très propre et correspondait aux photos. Tout était très soigné et décoré confortablement. Il y a d'excellents restaurants et boutiques dans les environs."},
  ],
};

const SITE_DEFAULT = {
  heroTitle:"Relax Luxury\nStays",
  heroSubtitle:"4 proprietà esclusive in Sicilia — dalla Scala dei Turchi alle ville con vista sui Templi. Superhost certificato Airbnb con oltre 437 recensioni ★★★★★",
  heroTagline:"Agrigento · Valle dei Templi · Sicilia",
  features:[
    {icon:"🏆",text:"Superhost certificato"},
    {icon:"★",text:"4,81 / 437 recensioni"},
    {icon:"🏛️",text:"Valle dei Templi UNESCO"},
    {icon:"🌊",text:"Scala dei Turchi"},
  ],
  contactEmail:"ugozunardi@gmail.com",
  contactPhone:"+39 348 809 9076",
  contactInstagram:"",
  contactFacebook:"",
  contactWhatsapp:"https://wa.me/393488099076",
  footerText:"Agrigento · Valle dei Templi · Sicilia, Italia",
};

// ─────────────────────────────────────────────────────────────────────────────
// AMENITIES & TYPES
// ─────────────────────────────────────────────────────────────────────────────
const AMENITY_MAP = {
  wifi:{icon:"📶",label:"Wi-Fi",labelEn:"Wi-Fi",labelEs:"Wi-Fi",labelFr:"Wi-Fi"},
  kitchen:{icon:"🍳",label:"Cucina",labelEn:"Kitchen",labelEs:"Cocina",labelFr:"Cuisine"},
  parking:{icon:"🚗",label:"Parcheggio",labelEn:"Parking",labelEs:"Aparcamiento",labelFr:"Parking"},
  tv:{icon:"📺",label:"Smart TV",labelEn:"Smart TV",labelEs:"Smart TV",labelFr:"Smart TV"},
  sea_view:{icon:"🌊",label:"Vista mare",labelEn:"Sea view",labelEs:"Vista al mar",labelFr:"Vue mer"},
  hairdryer:{icon:"💨",label:"Asciugacapelli",labelEn:"Hair dryer",labelEs:"Secador",labelFr:"Sèche-cheveux"},
  fridge:{icon:"🧊",label:"Frigorifero",labelEn:"Fridge",labelEs:"Nevera",labelFr:"Réfrigérateur"},
  workspace:{icon:"💻",label:"Area lavoro",labelEn:"Workspace",labelEs:"Zona de trabajo",labelFr:"Espace de travail"},
  ac:{icon:"❄️",label:"Aria cond.",labelEn:"A/C",labelEs:"Aire acond.",labelFr:"Climatisation"},
  pool:{icon:"🏊",label:"Piscina privata",labelEn:"Private pool",labelEs:"Piscina privada",labelFr:"Piscine privée"},
  bbq:{icon:"🔥",label:"Barbecue",labelEn:"Barbecue",labelEs:"Barbacoa",labelFr:"Barbecue"},
  garden:{icon:"🌿",label:"Giardino",labelEn:"Garden",labelEs:"Jardín",labelFr:"Jardin"},
  valley_view:{icon:"🏛️",label:"Vista Templi",labelEn:"Temples view",labelEs:"Vista Templos",labelFr:"Vue Temples"},
  elevator:{icon:"🛗",label:"Ascensore",labelEn:"Elevator",labelEs:"Ascensor",labelFr:"Ascenseur"},
  washer:{icon:"🫧",label:"Lavatrice",labelEn:"Washer",labelEs:"Lavadora",labelFr:"Lave-linge"},
  dryer:{icon:"🌀",label:"Asciugatrice",labelEn:"Dryer",labelEs:"Secadora",labelFr:"Sèche-linge"},
  terrace:{icon:"🌅",label:"Terrazza",labelEn:"Terrace",labelEs:"Terraza",labelFr:"Terrasse"},
};
const TYPE_LABEL = {HOUSE:"Casa",VILLA:"Villa",APARTMENT:"Appartamento"};

// ─────────────────────────────────────────────────────────────────────────────
// TRANSLATIONS
// ─────────────────────────────────────────────────────────────────────────────
const T = {
  it: {
    nav_props:"Proprietà", nav_contacts:"Contatti",
    filter_all:"Tutte", filter_house:"Case", filter_villa:"Ville", filter_apartment:"Appartamenti",
    search_ph:"🔍 Cerca per nome o città...",
    discover:"Scopri le Proprietà",
    per_night:"/notte", guests:"ospiti", beds:"letti", bath:"bagno", min_nights:"min",
    nights:"notti", night:"notte",
    checkin:"Check-in", checkout:"Check-out",
    back:"← Torna",
    amenities_title:"Dotazioni",
    rules_title:"Regole della Casa",
    avail_title:"Disponibilità",
    book_title:"Richiedi Prenotazione",
    book_name:"Nome *", book_email:"Email *", book_phone:"Telefono", book_guests:"N° ospiti", book_msg:"Messaggio",
    book_send:"Invia Richiesta di Prenotazione", book_sending:"⏳ Invio...",
    book_ok:"✓ Richiesta inviata! Vittorio ti risponderà entro 24 ore.",
    book_err:"✗ Errore. Riprova o contatta via email.",
    book_guarantee:"Risposta garantita entro 24 ore · Superhost Airbnb ★★★★★",
    book_msg_ph:"Domande, richieste speciali...",
    price_summary:"Riepilogo Prezzi", cleaning:"Pulizie", total:"Totale",
    cal_unavailable:"Non disponibile", cal_period:"Sel. periodo",
    rev_title:"Lascia una Recensione", rev_name:"Il tuo nome", rev_rating:"Valutazione",
    rev_text:"La tua recensione", rev_ph:"Racconta la tua esperienza...",
    rev_send:"Invia Recensione", rev_sent:"✓ Recensione inviata — verrà pubblicata dopo approvazione!",
    why_title:"Perché Prenotare Direttamente", why_sub:"I Vantaggi del Direct Booking",
    contact_title:"Contatta Vittorio",
    footer_copy:"© 2025 RelaxLuxuryStays · Superhost Airbnb certificato",
    show_photos:"Mostra tutte le foto",
    no_results:"Nessuna proprietà trovata.",
    remove_filters:"Rimuovi filtri",
    airbnb_btn:"Prenota su Airbnb",
    airbnb_view:"Vedi su Airbnb", airbnb_sub:"Prenota anche tramite Airbnb · Superhost certificato",
    prop_section:"La Proprietà",
    rooms:"cam.", stat_guests:"ospiti",
    MONTHS:["Gennaio","Febbraio","Marzo","Aprile","Maggio","Giugno","Luglio","Agosto","Settembre","Ottobre","Novembre","Dicembre"],
    DAYS:["Lu","Ma","Me","Gi","Ve","Sa","Do"],
    type_house:"Casa", type_villa:"Villa", type_apartment:"Appartamento",
    host_since:"Host dal 2013", explore:"Scopri →",
    where_title:"Dove sarai", where_verified:"La posizione di questo alloggio è verificata.", where_open:"Apri in Google Maps",
    rules_ci:"Check-in e check-out", rules_during:"Durante il soggiorno", rules_more:"Scopri di più", rules_subtitle:"Soggiornerai nell'alloggio di un'altra persona, ti preghiamo di trattarlo con cura e rispetto.",
    ci_abbr:"CI", co_abbr:"CO", reviews_short:"rec.",
    book_name_ph:"Nome e cognome", book_email_ph:"tua@email.com",
    review_one:"recensione", review_many:"recensioni", just_submitted:"Appena scritto",
    sub_pulizia:"Pulizia", sub_precisione:"Precisione", sub_checkin:"Check-in", sub_comunicazione:"Comunicazione", sub_posizione:"Posizione", sub_qualita:"Qualità/prezzo",
    guest_fav:"Amato dagli ospiti", guest_fav_sub:"Questo alloggio fa parte del 5% dei più apprezzati",
    all_reviews:"Vedi tutte le recensioni su Airbnb",
    guest_reviews:"Recensioni degli Ospiti",
    hero_subtitle:"4 proprietà esclusive in Sicilia — dalla Scala dei Turchi alle ville con vista sui Templi. Superhost certificato Airbnb con oltre 437 recensioni ★★★★★",
    hero_tagline:"Agrigento · Valle dei Templi · Sicilia",
    features:[
      {icon:"🏆",text:"Superhost certificato"},
      {icon:"★",text:"4,81 / 437 recensioni"},
      {icon:"🏛️",text:"Valle dei Templi UNESCO"},
      {icon:"🌊",text:"Scala dei Turchi"},
    ],
    why_items:[
      {icon:"💰",title:"Prezzi migliori",desc:"Senza commissioni Airbnb"},
      {icon:"💬",title:"Contatto diretto",desc:"Parla direttamente con Vittorio"},
      {icon:"🎁",title:"Flessibilità",desc:"Check-in/out flessibili"},
      {icon:"🔒",title:"Sicurezza",desc:"Conferma immediata"},
    ],
  },
  en: {
    nav_props:"Properties", nav_contacts:"Contacts",
    filter_all:"All", filter_house:"Houses", filter_villa:"Villas", filter_apartment:"Apartments",
    search_ph:"🔍 Search by name or city...",
    discover:"Explore Properties",
    per_night:"/night", guests:"guests", beds:"beds", bath:"bathroom", min_nights:"min",
    nights:"nights", night:"night",
    checkin:"Check-in", checkout:"Check-out",
    back:"← Back",
    amenities_title:"Amenities",
    rules_title:"House Rules",
    avail_title:"Availability",
    book_title:"Request Booking",
    book_name:"Name *", book_email:"Email *", book_phone:"Phone", book_guests:"N° guests", book_msg:"Message",
    book_send:"Send Booking Request", book_sending:"⏳ Sending...",
    book_ok:"✓ Request sent! Vittorio will reply within 24 hours.",
    book_err:"✗ Error. Please retry or contact via email.",
    book_guarantee:"Reply guaranteed within 24 hours · Airbnb Superhost ★★★★★",
    book_msg_ph:"Questions, special requests...",
    price_summary:"Price Summary", cleaning:"Cleaning", total:"Total",
    cal_unavailable:"Unavailable", cal_period:"Selected period",
    rev_title:"Leave a Review", rev_name:"Your name", rev_rating:"Rating",
    rev_text:"Your review", rev_ph:"Tell us about your stay...",
    rev_send:"Submit Review", rev_sent:"✓ Review submitted — will be published after approval!",
    why_title:"Why Book Directly", why_sub:"Direct Booking Benefits",
    contact_title:"Contact Vittorio",
    footer_copy:"© 2025 RelaxLuxuryStays · Certified Airbnb Superhost",
    show_photos:"Show all photos",
    no_results:"No properties found.",
    remove_filters:"Remove filters",
    airbnb_btn:"Book on Airbnb",
    airbnb_view:"View on Airbnb", airbnb_sub:"Book also via Airbnb · Certified Superhost",
    prop_section:"The Property",
    rooms:"rm.", stat_guests:"guests",
    MONTHS:["January","February","March","April","May","June","July","August","September","October","November","December"],
    DAYS:["Mo","Tu","We","Th","Fr","Sa","Su"],
    type_house:"House", type_villa:"Villa", type_apartment:"Apartment",
    host_since:"Host since 2013", explore:"Discover →",
    where_title:"Where you'll be", where_verified:"The location of this accommodation is verified.", where_open:"Open in Google Maps",
    rules_ci:"Check-in and check-out", rules_during:"During your stay", rules_more:"Learn more", rules_subtitle:"You'll be staying in someone else's home — please treat it with care and respect.",
    ci_abbr:"In", co_abbr:"Out", reviews_short:"rev.",
    book_name_ph:"Full name", book_email_ph:"your@email.com",
    review_one:"review", review_many:"reviews", just_submitted:"Just submitted",
    sub_pulizia:"Cleanliness", sub_precisione:"Accuracy", sub_checkin:"Check-in", sub_comunicazione:"Communication", sub_posizione:"Location", sub_qualita:"Value",
    guest_fav:"Guest favorite", guest_fav_sub:"This listing is in the top 5% based on ratings, reviews and reliability",
    all_reviews:"See all reviews on Airbnb",
    guest_reviews:"Guest Reviews",
    hero_subtitle:"4 exclusive properties in Sicily — from Scala dei Turchi to villas overlooking the Temples. Certified Airbnb Superhost with 437+ reviews ★★★★★",
    hero_tagline:"Agrigento · Valley of the Temples · Sicily",
    features:[
      {icon:"🏆",text:"Certified Superhost"},
      {icon:"★",text:"4.81 / 437 reviews"},
      {icon:"🏛️",text:"Valley of the Temples UNESCO"},
      {icon:"🌊",text:"Scala dei Turchi"},
    ],
    why_items:[
      {icon:"💰",title:"Better prices",desc:"No Airbnb commissions"},
      {icon:"💬",title:"Direct contact",desc:"Talk directly with Vittorio"},
      {icon:"🎁",title:"Flexibility",desc:"Flexible check-in/out"},
      {icon:"🔒",title:"Security",desc:"Immediate confirmation"},
    ],
  },
  es: {
    nav_props:"Propiedades", nav_contacts:"Contacto",
    filter_all:"Todas", filter_house:"Casas", filter_villa:"Villas", filter_apartment:"Apartamentos",
    search_ph:"🔍 Buscar por nombre o ciudad...",
    discover:"Explorar Propiedades",
    per_night:"/noche", guests:"huéspedes", beds:"camas", bath:"baño", min_nights:"mín",
    nights:"noches", night:"noche",
    checkin:"Llegada", checkout:"Salida",
    back:"← Volver",
    amenities_title:"Servicios",
    rules_title:"Normas de la Casa",
    avail_title:"Disponibilidad",
    book_title:"Solicitar Reserva",
    book_name:"Nombre *", book_email:"Email *", book_phone:"Teléfono", book_guests:"N° huéspedes", book_msg:"Mensaje",
    book_send:"Enviar Solicitud de Reserva", book_sending:"⏳ Enviando...",
    book_ok:"✓ ¡Solicitud enviada! Vittorio responderá en 24 horas.",
    book_err:"✗ Error. Inténtalo de nuevo o contacta por email.",
    book_guarantee:"Respuesta garantizada en 24 horas · Superhost Airbnb ★★★★★",
    book_msg_ph:"Preguntas, peticiones especiales...",
    price_summary:"Resumen de Precios", cleaning:"Limpieza", total:"Total",
    cal_unavailable:"No disponible", cal_period:"Período seleccionado",
    rev_title:"Deja una Reseña", rev_name:"Tu nombre", rev_rating:"Valoración",
    rev_text:"Tu reseña", rev_ph:"Cuéntanos tu experiencia...",
    rev_send:"Enviar Reseña", rev_sent:"✓ ¡Reseña enviada — se publicará tras aprobación!",
    why_title:"Por qué Reservar Directo", why_sub:"Ventajas de la Reserva Directa",
    contact_title:"Contactar a Vittorio",
    footer_copy:"© 2025 RelaxLuxuryStays · Superhost Airbnb certificado",
    show_photos:"Ver todas las fotos",
    no_results:"No se encontraron propiedades.",
    remove_filters:"Eliminar filtros",
    airbnb_btn:"Reservar en Airbnb",
    airbnb_view:"Ver en Airbnb", airbnb_sub:"Reserva también en Airbnb · Superhost certificado",
    prop_section:"La Propiedad",
    rooms:"hab.", stat_guests:"huéspedes",
    MONTHS:["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"],
    DAYS:["Lu","Ma","Mi","Ju","Vi","Sá","Do"],
    type_house:"Casa", type_villa:"Villa", type_apartment:"Apartamento",
    host_since:"Anfitrión desde 2013", explore:"Descubrir →",
    where_title:"Dónde estarás", where_verified:"La ubicación de este alojamiento está verificada.", where_open:"Abrir en Google Maps",
    rules_ci:"Llegada y salida", rules_during:"Durante la estancia", rules_more:"Saber más", rules_subtitle:"Estarás en el hogar de otra persona — por favor trátalo con cuidado y respeto.",
    ci_abbr:"LL", co_abbr:"SA", reviews_short:"rese.",
    book_name_ph:"Nombre y apellidos", book_email_ph:"tu@email.com",
    review_one:"reseña", review_many:"reseñas", just_submitted:"Recién enviado",
    sub_pulizia:"Limpieza", sub_precisione:"Precisión", sub_checkin:"Llegada", sub_comunicazione:"Comunicación", sub_posizione:"Ubicación", sub_qualita:"Relación calidad/precio",
    guest_fav:"Favorito de los huéspedes", guest_fav_sub:"Este alojamiento está en el top 5% de los más valorados",
    all_reviews:"Ver todas las reseñas en Airbnb",
    guest_reviews:"Reseñas de los Huéspedes",
    hero_subtitle:"4 propiedades exclusivas en Sicilia — desde Scala dei Turchi hasta villas con vistas a los Templos. Superhost certificado de Airbnb con más de 437 reseñas ★★★★★",
    hero_tagline:"Agrigento · Valle de los Templos · Sicilia",
    features:[
      {icon:"🏆",text:"Superhost certificado"},
      {icon:"★",text:"4,81 / 437 reseñas"},
      {icon:"🏛️",text:"Valle de los Templos UNESCO"},
      {icon:"🌊",text:"Scala dei Turchi"},
    ],
    why_items:[
      {icon:"💰",title:"Mejores precios",desc:"Sin comisiones de Airbnb"},
      {icon:"💬",title:"Contacto directo",desc:"Habla directamente con Vittorio"},
      {icon:"🎁",title:"Flexibilidad",desc:"Check-in/out flexible"},
      {icon:"🔒",title:"Seguridad",desc:"Confirmación inmediata"},
    ],
  },
  fr: {
    nav_props:"Propriétés", nav_contacts:"Contact",
    filter_all:"Toutes", filter_house:"Maisons", filter_villa:"Villas", filter_apartment:"Appartements",
    search_ph:"🔍 Rechercher par nom ou ville...",
    discover:"Explorer les Propriétés",
    per_night:"/nuit", guests:"voyageurs", beds:"lits", bath:"salle de bain", min_nights:"min",
    nights:"nuits", night:"nuit",
    checkin:"Arrivée", checkout:"Départ",
    back:"← Retour",
    amenities_title:"Équipements",
    rules_title:"Règlement Intérieur",
    avail_title:"Disponibilité",
    book_title:"Demande de Réservation",
    book_name:"Nom *", book_email:"Email *", book_phone:"Téléphone", book_guests:"Nb. voyageurs", book_msg:"Message",
    book_send:"Envoyer la Demande", book_sending:"⏳ Envoi...",
    book_ok:"✓ Demande envoyée ! Vittorio vous répondra sous 24 heures.",
    book_err:"✗ Erreur. Réessayez ou contactez par email.",
    book_guarantee:"Réponse garantie sous 24 heures · Superhost Airbnb ★★★★★",
    book_msg_ph:"Questions, demandes spéciales...",
    price_summary:"Récapitulatif des Prix", cleaning:"Ménage", total:"Total",
    cal_unavailable:"Indisponible", cal_period:"Période sélectionnée",
    rev_title:"Laisser un Avis", rev_name:"Votre nom", rev_rating:"Note",
    rev_text:"Votre avis", rev_ph:"Parlez-nous de votre séjour...",
    rev_send:"Soumettre l'Avis", rev_sent:"✓ Avis soumis — sera publié après approbation !",
    why_title:"Pourquoi Réserver en Direct", why_sub:"Avantages de la Réservation Directe",
    contact_title:"Contacter Vittorio",
    footer_copy:"© 2025 RelaxLuxuryStays · Superhost Airbnb certifié",
    show_photos:"Voir toutes les photos",
    no_results:"Aucune propriété trouvée.",
    remove_filters:"Supprimer les filtres",
    airbnb_btn:"Réserver sur Airbnb",
    airbnb_view:"Voir sur Airbnb", airbnb_sub:"Réservez aussi via Airbnb · Superhost certifié",
    prop_section:"La Propriété",
    rooms:"ch.", stat_guests:"voyageurs",
    MONTHS:["Janvier","Février","Mars","Avril","Mai","Juin","Juillet","Août","Septembre","Octobre","Novembre","Décembre"],
    DAYS:["Lu","Ma","Me","Je","Ve","Sa","Di"],
    type_house:"Maison", type_villa:"Villa", type_apartment:"Appartement",
    host_since:"Hôte depuis 2013", explore:"Découvrir →",
    where_title:"Où vous serez", where_verified:"L'emplacement de ce logement est vérifié.", where_open:"Ouvrir dans Google Maps",
    rules_ci:"Arrivée et départ", rules_during:"Pendant le séjour", rules_more:"En savoir plus", rules_subtitle:"Vous séjournerez chez quelqu'un d'autre — veuillez le traiter avec soin et respect.",
    ci_abbr:"Arr", co_abbr:"Dép", reviews_short:"avis",
    book_name_ph:"Nom et prénom", book_email_ph:"votre@email.com",
    review_one:"avis", review_many:"avis", just_submitted:"Vient d'être soumis",
    sub_pulizia:"Propreté", sub_precisione:"Exactitude", sub_checkin:"Arrivée", sub_comunicazione:"Communication", sub_posizione:"Emplacement", sub_qualita:"Qualité-prix",
    guest_fav:"Coup de cœur des voyageurs", guest_fav_sub:"Ce logement est dans le top 5% des plus appréciés",
    all_reviews:"Voir tous les avis sur Airbnb",
    guest_reviews:"Avis des Voyageurs",
    hero_subtitle:"4 propriétés exclusives en Sicile — de Scala dei Turchi aux villas avec vue sur les Temples. Superhost Airbnb certifié avec plus de 437 avis ★★★★★",
    hero_tagline:"Agrigento · Vallée des Temples · Sicile",
    features:[
      {icon:"🏆",text:"Superhost certifié"},
      {icon:"★",text:"4,81 / 437 avis"},
      {icon:"🏛️",text:"Vallée des Temples UNESCO"},
      {icon:"🌊",text:"Scala dei Turchi"},
    ],
    why_items:[
      {icon:"💰",title:"Meilleurs prix",desc:"Sans commissions Airbnb"},
      {icon:"💬",title:"Contact direct",desc:"Parlez directement avec Vittorio"},
      {icon:"🎁",title:"Flexibilité",desc:"Arrivée/départ flexibles"},
      {icon:"🔒",title:"Sécurité",desc:"Confirmation immédiate"},
    ],
  },
};

// ─────────────────────────────────────────────────────────────────────────────
// STORAGE HELPERS
// ─────────────────────────────────────────────────────────────────────────────
// Translate review dates (stored as Italian month names) to current language
function translateDate(dateStr, lang) {
  if (!dateStr || lang === "it") return dateStr;
  const idx = T.it.MONTHS.findIndex(m => dateStr.startsWith(m));
  if (idx === -1) return dateStr;
  const year = dateStr.substring(T.it.MONTHS[idx].length).trim();
  return T[lang]?.MONTHS?.[idx] ? T[lang].MONTHS[idx] + (year ? " " + year : "") : dateStr;
}

// Translate "N anni/mesi su Airbnb" location strings
function translateLocation(location, lang) {
  if (!location || lang === "it") return location;
  const anniMatch = location.match(/^(\d+) anni su Airbnb$/);
  const mesiMatch = location.match(/^(\d+) mesi su Airbnb$/);
  if (anniMatch) {
    const n = anniMatch[1];
    if (lang === "en") return `${n} years on Airbnb`;
    if (lang === "es") return `${n} años en Airbnb`;
    if (lang === "fr") return `${n} ans sur Airbnb`;
  }
  if (mesiMatch) {
    const n = mesiMatch[1];
    if (lang === "en") return `${n} months on Airbnb`;
    if (lang === "es") return `${n} meses en Airbnb`;
    if (lang === "fr") return `${n} mois sur Airbnb`;
  }
  return location;
}

const LS = {
  get: (k, def) => { try { const v = localStorage.getItem(k); return v ? JSON.parse(v) : def; } catch { return def; } },
  set: (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)); } catch {} },
};

// ─────────────────────────────────────────────────────────────────────────────
// AUTH HELPERS
// ─────────────────────────────────────────────────────────────────────────────
function getSession() { return LS.get("rls_session", null); }
function saveSession(u) { LS.set("rls_session", { email: u.email, name: u.name }); }
function clearSession() {
  localStorage.removeItem("rls_session");
  fetch("/api/logout", { method: "POST" }).catch(() => {});
}

// ─── EMAIL — le credenziali EmailJS sono gestite server-side in /api/send-email ──
async function sendEmail(params) {
  const res = await fetch("/api/send-email", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(params),
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || "Errore invio email");
  }
  return res.json();
}

// ─────────────────────────────────────────────────────────────────────────────
// SHARED DATABASE — via Netlify Function proxy (no CORS issues)
// ─────────────────────────────────────────────────────────────────────────────
const DB_URL = "/api/db";
const JSONBIN_CONFIGURED = true;
const SHOW_PRICES = false; // ← true per mostrare i prezzi, false per nasconderli

async function jbRead() {
  try {
    const res = await fetch(DB_URL);
    if (!res.ok) return null;
    return await res.json();
  } catch { return null; }
}

async function jbWrite(data) {
  try {
    // Strip base64 images to keep payload small (keep URL paths)
    const clean = {
      ...data,
      props: data.props ? data.props.map(p => ({
        ...p,
        cover: p.cover && p.cover.startsWith("data:") ? "" : (p.cover||""),
        images: p.images ? p.images.filter(img => !img.startsWith("data:")) : [],
      })) : data.props,
    };
    const res = await fetch(DB_URL, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(clean),
    });
    if (!res.ok) console.error("[DB] write failed:", res.status, await res.text());
    else console.log("[DB] write OK");
  } catch(err) { console.error("[DB] write error:", err); }
}

// ─────────────────────────────────────────────────────────────────────────────
// DATE HELPERS
// ─────────────────────────────────────────────────────────────────────────────
function fmtDate(d) {
  if (!d) return "";
  const months = ["Gen","Feb","Mar","Apr","Mag","Giu","Lug","Ago","Set","Ott","Nov","Dic"];
  return `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}`;
}
function diffDays(a,b) { return Math.round((b-a)/86400000); }
function addDays(d,n) { const r=new Date(d); r.setDate(r.getDate()+n); return r; }
function toISO(d) { if(!d) return ""; const y=d.getFullYear(),m=String(d.getMonth()+1).padStart(2,'0'),day=String(d.getDate()).padStart(2,'0'); return `${y}-${m}-${day}`; }

function getPriceForDate(isoDate, prop) {
  const rules = prop.priceRules || [];
  const rule = rules.find(r => isoDate >= r.from && isoDate < r.to);
  return rule ? rule.price : prop.price;
}

function calcStayPrice(checkIn, checkOut, prop) {
  // Returns { subtotal, nights, segments } where segments = [{price, nights, label}]
  const nights = diffDays(checkIn, checkOut);
  if (nights < 1) return { subtotal: 0, nights: 0, segments: [] };
  const segments = [];
  let d = new Date(checkIn);
  for (let i = 0; i < nights; i++) {
    const iso = toISO(d);
    const price = getPriceForDate(iso, prop);
    const last = segments[segments.length - 1];
    if (last && last.price === price) {
      last.nights++;
    } else {
      const rule = (prop.priceRules || []).find(r => iso >= r.from && iso < r.to);
      segments.push({ price, nights: 1, label: rule ? rule.label : null });
    }
    d.setDate(d.getDate() + 1);
  }
  const subtotal = segments.reduce((s, seg) => s + seg.price * seg.nights, 0);
  return { subtotal, nights, segments };
}

// ─────────────────────────────────────────────────────────────────────────────
// Stars
// ─────────────────────────────────────────────────────────────────────────────
function Stars({value, onChange}) {
  const [hover,setHover] = useState(0);
  return (
    <span style={{display:"inline-flex",gap:2}}>
      {[1,2,3,4,5].map(i => (
        <span key={i} className="star"
          style={{color:i<=(hover||value)?"#c49535":"#d4d0cc"}}
          onMouseEnter={()=>onChange&&setHover(i)}
          onMouseLeave={()=>onChange&&setHover(0)}
          onClick={()=>onChange&&onChange(i)}>★</span>
      ))}
    </span>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// Lightbox
// ─────────────────────────────────────────────────────────────────────────────
function Lightbox({images,startIdx,onClose}) {
  const [idx,setIdx] = useState(startIdx);
  const touchX = useRef(null);
  const thumbsRef = useRef(null);

  useEffect(() => {
    const h = e => {
      if(e.key==="ArrowRight") setIdx(i=>(i+1)%images.length);
      if(e.key==="ArrowLeft") setIdx(i=>(i-1+images.length)%images.length);
      if(e.key==="Escape") onClose();
    };
    window.addEventListener("keydown",h);
    return ()=>window.removeEventListener("keydown",h);
  },[images.length,onClose]);

  // Scroll active thumbnail into view
  useEffect(()=>{
    if(thumbsRef.current){
      const active=thumbsRef.current.children[idx];
      if(active) active.scrollIntoView({behavior:"smooth",block:"nearest",inline:"center"});
    }
  },[idx]);

  function handleTouchStart(e){ touchX.current=e.touches[0].clientX; }
  function handleTouchEnd(e){
    if(touchX.current===null) return;
    const diff=touchX.current-e.changedTouches[0].clientX;
    if(Math.abs(diff)>50){ diff>0?setIdx(i=>(i+1)%images.length):setIdx(i=>(i-1+images.length)%images.length); }
    touchX.current=null;
  }

  return (
    <div className="fi" onClick={onClose} style={{position:"fixed",inset:0,background:"rgba(0,0,0,.95)",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",zIndex:9999}}>
      {/* Top bar */}
      <div style={{position:"absolute",top:0,left:0,right:0,display:"flex",alignItems:"center",justifyContent:"space-between",padding:"14px 20px",background:"linear-gradient(rgba(0,0,0,.5),transparent)"}}>
        <span style={{color:"rgba(255,255,255,.7)",fontSize:13}}>{idx+1} / {images.length}</span>
        <button onClick={onClose} style={{background:"rgba(255,255,255,.12)",border:"none",color:"#fff",fontSize:20,cursor:"pointer",width:38,height:38,borderRadius:"50%",display:"flex",alignItems:"center",justifyContent:"center"}}>✕</button>
      </div>
      {/* Prev */}
      <button onClick={e=>{e.stopPropagation();setIdx(i=>(i-1+images.length)%images.length);}}
        style={{position:"absolute",left:16,background:"rgba(255,255,255,.12)",border:"none",color:"#fff",fontSize:28,cursor:"pointer",width:52,height:52,borderRadius:"50%",backdropFilter:"blur(4px)"}}>‹</button>
      {/* Main image */}
      <img src={images[idx]} alt=""
        style={{maxWidth:"90vw",maxHeight:"72vh",objectFit:"contain",borderRadius:4,userSelect:"none"}}
        onClick={e=>e.stopPropagation()}
        onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd}/>
      {/* Next */}
      <button onClick={e=>{e.stopPropagation();setIdx(i=>(i+1)%images.length);}}
        style={{position:"absolute",right:16,background:"rgba(255,255,255,.12)",border:"none",color:"#fff",fontSize:28,cursor:"pointer",width:52,height:52,borderRadius:"50%",backdropFilter:"blur(4px)"}}>›</button>
      {/* Thumbnails */}
      <div ref={thumbsRef} onClick={e=>e.stopPropagation()}
        style={{display:"flex",gap:6,overflowX:"auto",maxWidth:"90vw",padding:"12px 4px 4px",scrollbarWidth:"none"}}>
        {images.map((src,i)=>(
          <img key={i} src={src} alt="" onClick={e=>{e.stopPropagation();setIdx(i);}}
            style={{width:58,height:40,objectFit:"cover",borderRadius:2,cursor:"pointer",flexShrink:0,
              border:i===idx?"2px solid #c49535":"2px solid transparent",
              opacity:i===idx?1:.5,transition:"all .15s"}}/>
        ))}
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// AvailCalendar
// ─────────────────────────────────────────────────────────────────────────────
function AvailCalendar({propId,blockedDates,onRangeChange,minN,lang="it",prop=null}) {
  const today = new Date(); today.setHours(0,0,0,0);
  const [viewYear,setViewYear] = useState(today.getFullYear());
  const [viewMonth,setViewMonth] = useState(today.getMonth());
  const [checkIn,setCheckIn] = useState(null);
  const [checkOut,setCheckOut] = useState(null);
  const [hovDay,setHovDay] = useState(null);
  const blocked = blockedDates[propId]||[];

  // Add min-stay gap blocks: gaps between bookings shorter than minN nights
  const effectiveBlocked = [...blocked];
  if(minN>1){
    const sorted=[...blocked].sort((a,b)=>a.from<b.from?-1:1);
    for(let i=0;i<sorted.length-1;i++){
      const gapStart=sorted[i].to, gapEnd=sorted[i+1].from;
      const days=diffDays(new Date(gapStart),new Date(gapEnd));
      if(days>0&&days<minN) effectiveBlocked.push({from:gapStart,to:gapEnd});
    }
  }

  function isBlocked(d) { const iso=toISO(d); return effectiveBlocked.some(r=>iso>=r.from&&iso<r.to); }
  function isPast(d) { return d<today; }

  function handleDay(d) {
    if(isPast(d)||isBlocked(d)) return;
    if(!checkIn||(checkIn&&checkOut)) { setCheckIn(d);setCheckOut(null);onRangeChange&&onRangeChange(null,null); }
    else {
      if(d<=checkIn){setCheckIn(d);setCheckOut(null);return;}
      let cur=addDays(checkIn,1);
      while(cur<d){if(isBlocked(cur)){setCheckIn(d);setCheckOut(null);return;}cur=addDays(cur,1);}
      setCheckOut(d);onRangeChange&&onRangeChange(checkIn,d);
    }
  }
  function inRange(d) {
    if(!checkIn) return false;
    const ref=checkOut||hovDay; if(!ref) return false;
    return d>checkIn&&d<ref;
  }
  const firstDay=new Date(viewYear,viewMonth,1).getDay();
  const daysInMonth=new Date(viewYear,viewMonth+1,0).getDate();
  const DAYS=T[lang].DAYS;
  const MONTHS=T[lang].MONTHS;
  const cells=[];
  const offset=(firstDay+6)%7;
  for(let i=0;i<offset;i++) cells.push(null);
  for(let d=1;d<=daysInMonth;d++) cells.push(new Date(viewYear,viewMonth,d));

  return (
    <div className="cal-wrap" style={{fontFamily:"'Jost',sans-serif"}}>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:12}}>
        <button className="btn-o" style={{padding:"4px 10px",fontSize:16}} onClick={()=>{let m=viewMonth-1,y=viewYear;if(m<0){m=11;y--;}setViewMonth(m);setViewYear(y);}}>‹</button>
        <span style={{fontWeight:500,fontSize:13}}>{MONTHS[viewMonth]} {viewYear}</span>
        <button className="btn-o" style={{padding:"4px 10px",fontSize:16}} onClick={()=>{let m=viewMonth+1,y=viewYear;if(m>11){m=0;y++;}setViewMonth(m);setViewYear(y);}}>›</button>
      </div>
      <div style={{display:"grid",gridTemplateColumns:`repeat(7,${prop?"40px":"36px"})`,gap:2,justifyContent:"center",marginBottom:4}}>
        {DAYS.map(d=><div key={d} style={{textAlign:"center",fontSize:10,fontWeight:500,color:"#79716c",letterSpacing:".08em"}}>{d}</div>)}
      </div>
      <div style={{display:"grid",gridTemplateColumns:`repeat(7,${prop?"40px":"36px"})`,gap:2,justifyContent:"center"}}>
        {cells.map((d,i)=>{
          if(!d) return <div key={"e"+i}/>;
          const iso=toISO(d),sel=(checkIn&&iso===toISO(checkIn))||(checkOut&&iso===toISO(checkOut)),past=isPast(d),block=isBlocked(d),todayCls=iso===toISO(today)?"cal-today":"",rangeCls=inRange(d)?"cal-in-range":"";
          const dayPrice=prop&&!past&&!block?getPriceForDate(iso,prop):null;
          return <div key={iso} className={`cal-day ${past?"cal-past":""} ${block?"cal-blocked":""} ${sel?"cal-selected":""} ${rangeCls} ${todayCls}`}
            style={prop?{flexDirection:"column",gap:0,height:44,width:40}:{}}
            onMouseEnter={()=>{if(checkIn&&!checkOut)setHovDay(d);}} onMouseLeave={()=>setHovDay(null)} onClick={()=>handleDay(d)}>
            <span style={prop?{fontSize:11,lineHeight:1.2}:{}}>{d.getDate()}</span>
            {SHOW_PRICES&&dayPrice!==null&&<span style={{fontSize:8,lineHeight:1,color:sel?"rgba(245,240,235,.8)":rangeCls?"#b08a20":"#c49535",fontWeight:500}}>€{dayPrice}</span>}
          </div>;
        })}
      </div>
      {(checkIn||checkOut)&&(
        <div style={{marginTop:12,padding:"10px 12px",background:"#f5f0eb",fontSize:12,display:"flex",gap:16,flexWrap:"wrap"}}>
          <span>📅 Check-in: <strong>{checkIn?fmtDate(checkIn):"—"}</strong></span>
          <span>📅 Check-out: <strong>{checkOut?fmtDate(checkOut):"—"}</strong></span>
          {checkIn&&checkOut&&<span>🌙 {T[lang].nights}: <strong>{diffDays(checkIn,checkOut)}</strong></span>}
        </div>
      )}
      <div style={{marginTop:8,display:"flex",gap:12,fontSize:10,color:"#79716c"}}>
        <span><span style={{background:"#fee2e2",padding:"1px 5px",borderRadius:2}}>nn</span> {T[lang].cal_unavailable}</span>
        <span><span style={{background:"#fef9c3",padding:"1px 5px",borderRadius:2}}>nn</span> {T[lang].cal_period}</span>
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// PriceBreakdown
// ─────────────────────────────────────────────────────────────────────────────
function PriceBreakdown({prop,checkIn,checkOut,lang="it"}) {
  if(!checkIn||!checkOut) return null;
  const {subtotal,nights,segments} = calcStayPrice(checkIn,checkOut,prop);
  if(nights<1) return null;
  const total = subtotal + prop.cleaning;
  return (
    <div style={{marginTop:16,border:"1px solid #e8e4e0",padding:16,background:"#fafaf8"}}>
      {SHOW_PRICES&&<><div className="sl" style={{marginBottom:10}}>{T[lang].price_summary}</div>
      <div style={{fontSize:13,lineHeight:2}}>
        {segments.map((seg,i)=>(
          <div key={i} style={{display:"flex",justifyContent:"space-between"}}>
            <span>€{seg.price} × {seg.nights} {seg.nights===1?T[lang].night:T[lang].nights}{seg.label?` (${seg.label})`:""}</span>
            <span>€{seg.price*seg.nights}</span>
          </div>
        ))}
        <div style={{display:"flex",justifyContent:"space-between",color:"#79716c"}}><span>{T[lang].cleaning}</span><span>€{prop.cleaning}</span></div>
        <div style={{display:"flex",justifyContent:"space-between",fontWeight:600,borderTop:"1px solid #e8e4e0",paddingTop:8,marginTop:4}}><span>{T[lang].total}</span><span style={{color:"#c49535"}}>€{total}</span></div>
      </div></>}
      <div style={{marginTop:8,fontSize:10,color:"#79716c"}}>✓ {T[lang].checkin}: {fmtDate(checkIn)} · {T[lang].checkout}: {fmtDate(checkOut)} · {nights} {nights===1?T[lang].night:T[lang].nights}</div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// ReviewSection (public)
// ─────────────────────────────────────────────────────────────────────────────
function ReviewSection({propId,reviews,setReviews,prop,lang="it"}) {
  const [form,setForm] = useState({name:"",text:"",rating:5});
  const [sent,setSent] = useState(false);
  const propReviews = (reviews[propId]||[]).filter(r=>r.approved!==false);
  const airbnbRating = prop?.airbnbRating;
  const airbnbReviews = prop?.airbnbReviews;
  const sub = prop?.airbnbSubRatings;
  const isGuestFav = airbnbRating && airbnbRating >= 4.9;

  function submit(e) {
    e.preventDefault();
    if(!form.name.trim()||!form.text.trim()) return;
    const newR={id:"u"+Date.now(),name:form.name,country:"🌍",date:T[lang].just_submitted,rating:form.rating,text:form.text,approved:false};
    const updated={...reviews,[propId]:[...((reviews[propId]||[])),newR]};
    setReviews(updated); LS.set("rls_reviews",updated);
    setSent(true); setForm({name:"",text:"",rating:5});
    setTimeout(()=>setSent(false),4000);
  }

  const subKeys = [
    {key:"pulizia",label:T[lang].sub_pulizia},
    {key:"precisione",label:T[lang].sub_precisione},
    {key:"checkin",label:T[lang].sub_checkin},
    {key:"comunicazione",label:T[lang].sub_comunicazione},
    {key:"posizione",label:T[lang].sub_posizione},
    {key:"qualita",label:T[lang].sub_qualita},
  ];

  return (
    <div style={{marginTop:40}}>
      {/* Airbnb-style rating header */}
      {airbnbRating&&(
        <div style={{textAlign:"center",marginBottom:32,padding:"32px 24px",background:"#fff",border:"1px solid #eee",borderRadius:8}}>
          {isGuestFav&&<div style={{fontSize:28,marginBottom:4}}>🏅</div>}
          <div style={{fontSize:52,fontWeight:700,lineHeight:1,fontFamily:"'Cormorant Garamond',serif",color:"#1a1816",marginBottom:4}}>{airbnbRating}</div>
          {isGuestFav&&(<>
            <div style={{fontSize:15,fontWeight:600,marginBottom:4}}>{T[lang].guest_fav}</div>
            <div style={{fontSize:12,color:"#79716c",maxWidth:300,margin:"0 auto 16px"}}>{T[lang].guest_fav_sub}</div>
          </>)}
          {/* Sub-ratings */}
          {sub&&(
            <div className="sub-ratings-grid" style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:16,maxWidth:600,margin:"16px auto 0",textAlign:"left"}}>
              {subKeys.map(({key,label})=>(
                <div key={key}>
                  <div style={{display:"flex",justifyContent:"space-between",fontSize:12,marginBottom:4}}>
                    <span style={{color:"#1a1816"}}>{label}</span>
                    <span style={{fontWeight:600}}>{sub[key]?.toFixed(1)}</span>
                  </div>
                  <div style={{height:3,background:"#eee",borderRadius:2}}>
                    <div style={{width:`${(sub[key]/5)*100}%`,height:"100%",background:"#1a1816",borderRadius:2}}/>
                  </div>
                </div>
              ))}
            </div>
          )}
          {/* Link to all Airbnb reviews */}
          {prop?.airbnbUrl&&(
            <a href={prop.airbnbUrl+"#reviews"} target="_blank" rel="noreferrer" className="airbnb-link"
              style={{display:"inline-flex",alignItems:"center",gap:6,marginTop:20,fontSize:12,color:"#FF5A5F",fontWeight:500,textDecoration:"none",border:"1px solid #FF5A5F",padding:"8px 16px",borderRadius:20}}>
              🏠 {T[lang].all_reviews} ({airbnbReviews})
            </a>
          )}
        </div>
      )}

      {/* Review cards */}
      {propReviews.length>0&&(
        <div style={{marginBottom:32}}>
          <div className="sl" style={{marginBottom:16}}>{T[lang].guest_reviews}</div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(300px,1fr))",gap:20}}>
            {propReviews.map(r=>(
              <div key={r.id} style={{padding:20,background:"#fff",border:"1px solid #eee",borderRadius:4}}>
                <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:12}}>
                  <div style={{width:40,height:40,borderRadius:"50%",background:"#c49535",display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontSize:15,fontWeight:600,flexShrink:0}}>
                    {r.name.charAt(0).toUpperCase()}
                  </div>
                  <div>
                    <div style={{fontWeight:500,fontSize:14}}>{r.name} {r.country}</div>
                    {r.location&&<div style={{fontSize:11,color:"#79716c"}}>{translateLocation(r.location,lang)}</div>}
                    <div style={{fontSize:11,color:"#79716c",marginTop:1}}>{translateDate(r.date,lang)}</div>
                  </div>
                </div>
                <div style={{display:"flex",gap:2,marginBottom:10}}>
                  {[1,2,3,4,5].map(i=><span key={i} style={{color:i<=r.rating?"#c49535":"#e0dbd5",fontSize:12}}>★</span>)}
                </div>
                <p style={{fontSize:13,lineHeight:1.65,color:"#3a3530"}}>{lang==="es"?(r.textEs||r.textEn||r.text):lang==="fr"?(r.textFr||r.textEn||r.text):lang==="en"?(r.textEn||r.text):r.text}</p>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Leave a review form */}
      <div style={{background:"#f5f0eb",padding:24,borderRadius:4}}>
        <div className="sl" style={{marginBottom:16}}>{T[lang].rev_title}</div>
        {sent&&<div style={{background:"#dcfce7",color:"#15803d",padding:"10px 14px",fontSize:13,marginBottom:12,borderRadius:2}}>{T[lang].rev_sent}</div>}
        <form onSubmit={submit} style={{display:"grid",gap:12}}>
          <div><label className="lbl">{T[lang].rev_name}</label><input className="inp" value={form.name} onChange={e=>setForm({...form,name:e.target.value})} placeholder={T[lang].rev_name}/></div>
          <div><label className="lbl">{T[lang].rev_rating}</label><Stars value={form.rating} onChange={v=>setForm({...form,rating:v})}/></div>
          <div><label className="lbl">{T[lang].rev_text}</label><textarea className="inp" rows={3} value={form.text} onChange={e=>setForm({...form,text:e.target.value})} placeholder={T[lang].rev_ph}/></div>
          <button className="btn-d" type="submit" style={{alignSelf:"flex-start"}}>{T[lang].rev_send}</button>
        </form>
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// ImgUploader
// ─────────────────────────────────────────────────────────────────────────────
function ImgUploader({label,onUpload,multiple}) {
  const ref=useRef();
  const [uploading,setUploading]=useState(false);
  async function uploadOne(file) {
    return new Promise((resolve,reject)=>{
      const r=new FileReader();
      r.onload=async e=>{
        try {
          const res=await fetch("/api/image",{
            method:"POST",
            headers:{"Content-Type":"application/json"},
            body:JSON.stringify({base64:e.target.result,contentType:file.type}),
          });
          if(!res.ok) throw new Error("upload failed");
          const {url}=await res.json();
          resolve(url);
        } catch(err){reject(err);}
      };
      r.readAsDataURL(file);
    });
  }
  async function handleFiles(files) {
    setUploading(true);
    try {
      const urls=await Promise.all(Array.from(files).map(uploadOne));
      onUpload(multiple?urls:urls[0]);
    } catch { alert("Errore durante il caricamento. Riprova."); }
    setUploading(false);
  }
  return (
    <div>
      <input ref={ref} type="file" accept="image/*" multiple={!!multiple} style={{display:"none"}} onChange={e=>handleFiles(e.target.files)}/>
      <button className="btn-o" style={{fontSize:11}} onClick={()=>ref.current.click()} disabled={uploading}>
        {uploading?"⏳ Caricamento...":"📎 "+(label||"Carica foto")}
      </button>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// AUTH SCREEN
// ─────────────────────────────────────────────────────────────────────────────
function AuthScreen({onSuccess,onBack}) {
  const [email,setEmail] = useState("");
  const [password,setPassword] = useState("");
  const [err,setErr] = useState("");
  const [sending,setSending] = useState(false);
  const [otpStep,setOtpStep] = useState(false);
  const [otpInput,setOtpInput] = useState("");
  const [pendingToken,setPendingToken] = useState("");

  async function handleLogin(e) {
    e.preventDefault();
    setErr("");
    setSending(true);
    try {
      const res = await fetch("/api/auth", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) { setErr(data.error || "Credenziali non valide."); return; }
      setPendingToken(data.preAuthToken);
      setOtpInput("");
      setOtpStep(true);
    } catch(ex) { setErr("Errore di rete: " + ex.message); }
    finally { setSending(false); }
  }

  async function handleVerifyOtp(e) {
    e.preventDefault();
    setSending(true); setErr("");
    try {
      const res = await fetch("/api/verify-otp", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ preAuthToken: pendingToken, otp: otpInput.trim() }),
      });
      const data = await res.json();
      if (!res.ok) { setErr(data.error || "Codice non valido."); return; }
      saveSession({ email: data.email, name: data.name });
      onSuccess({ email: data.email, name: data.name });
    } catch(ex) { setErr("Errore di rete: " + ex.message); }
    finally { setSending(false); }
  }

  const Logo = ()=>(
    <div style={{textAlign:"center",marginBottom:28}}>
      <div style={{width:44,height:44,background:"#c49535",borderRadius:"50%",display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 12px"}}>
        <span style={{color:"#fff",fontSize:18,fontWeight:700}}>R</span>
      </div>
      <h1 className="df" style={{fontSize:22,fontWeight:400}}>RelaxLuxuryStays</h1>
      <p style={{fontSize:11,color:"#79716c",marginTop:4}}>Pannello Amministratore</p>
    </div>
  );

  if(otpStep) return (
    <div style={{minHeight:"100vh",background:"#fafaf8",display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div style={{width:"100%",maxWidth:420,background:"#fff",border:"1px solid #eee",padding:40}}>
        <Logo/>
        <div style={{textAlign:"center",marginBottom:24}}>
          <div style={{fontSize:32,marginBottom:8}}>📧</div>
          <p style={{fontSize:13,color:"#1a1816",fontWeight:500}}>Verifica la tua identità</p>
          <p style={{fontSize:12,color:"#79716c",marginTop:6}}>
            Codice inviato via email. Valido 10 minuti.
          </p>
        </div>
        {err&&<div style={{background:"#fee2e2",color:"#dc2626",padding:"10px 14px",fontSize:12,marginBottom:16,borderRadius:2}}>{err}</div>}
        <form onSubmit={handleVerifyOtp} style={{display:"grid",gap:14}}>
          <div>
            <label className="lbl">Codice di verifica</label>
            <input className="inp" required autoFocus maxLength={6} value={otpInput} onChange={e=>{setOtpInput(e.target.value);setErr("");}} placeholder="000000" style={{textAlign:"center",letterSpacing:".3em",fontSize:20,fontWeight:600}}/>
          </div>
          <button className="btn-d" type="submit" style={{width:"100%",justifyContent:"center"}}>Verifica e Accedi</button>
        </form>
        <button className="btn-o" onClick={()=>{setOtpStep(false);setErr("");}} style={{width:"100%",justifyContent:"center",marginTop:10,fontSize:11}}>← Torna al login</button>
      </div>
    </div>
  );

  return (
    <div style={{minHeight:"100vh",background:"#fafaf8",display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div style={{width:"100%",maxWidth:420,background:"#fff",border:"1px solid #eee",padding:40}}>
        <Logo/>
        {err&&<div style={{background:"#fee2e2",color:"#dc2626",padding:"10px 14px",fontSize:12,marginBottom:16,borderRadius:2}}>{err}</div>}
        <form onSubmit={handleLogin} style={{display:"grid",gap:14}}>
          <div><label className="lbl">Email</label><input className="inp" type="email" required value={email} onChange={e=>{setEmail(e.target.value);setErr("");}} placeholder="tua@email.com" autoFocus/></div>
          <div><label className="lbl">Password</label><input className="inp" type="password" required value={password} onChange={e=>{setPassword(e.target.value);setErr("");}} placeholder="••••••••"/></div>
          <button className="btn-d" type="submit" disabled={sending} style={{width:"100%",justifyContent:"center",marginTop:4,opacity:sending?.6:1}}>
            {sending?"⏳ Invio codice...":"Accedi all'Admin"}
          </button>
        </form>
        <button className="btn-o" onClick={onBack} style={{width:"100%",justifyContent:"center",marginTop:12,fontSize:11}}>← Torna al sito</button>
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// iCal parser
// ─────────────────────────────────────────────────────────────────────────────
function parseIcal(text) {
  const events = [];
  const re = /BEGIN:VEVENT[\s\S]*?END:VEVENT/g;
  let match;
  while ((match = re.exec(text)) !== null) {
    const ds = match[0].match(/DTSTART(?:;[^:\r\n]*)?:(\d{8})/);
    const de = match[0].match(/DTEND(?:;[^:\r\n]*)?:(\d{8})/);
    if (ds && de) {
      const from = ds[1].replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3');
      const to   = de[1].replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3');
      if (from < to) events.push({ from, to });
    }
  }
  return events;
}

// ─────────────────────────────────────────────────────────────────────────────
// ADMIN — Property Form
// ─────────────────────────────────────────────────────────────────────────────
function PropForm({prop,onSave,onCancel,blockedDates,setBlockedDates,dbSave}) {
  const [form,setForm] = useState({...prop});
  const [newBlFrom,setNewBlFrom] = useState("");
  const [newBlTo,setNewBlTo] = useState("");
  const [icalUrl,setIcalUrl] = useState(prop.icalUrl||"");
  const [icalStatus,setIcalStatus] = useState("");
  const blocked=blockedDates[prop.id]||[];

  function f(k,v){setForm(p=>({...p,[k]:v}));}

  function addBlocked(){
    if(!newBlFrom||!newBlTo||newBlFrom>newBlTo) return;
    const updated={...blockedDates,[prop.id]:[...blocked,{from:newBlFrom,to:newBlTo}]};
    setBlockedDates(updated); LS.set("rls_blocked",updated); dbSave({blockedDates:updated});
    setNewBlFrom("");setNewBlTo("");
  }
  function removeBlocked(idx){
    const updated={...blockedDates,[prop.id]:blocked.filter((_,i)=>i!==idx)};
    setBlockedDates(updated); LS.set("rls_blocked",updated); dbSave({blockedDates:updated});
  }

  async function syncIcal() {
    if(!icalUrl.trim()){setIcalStatus("❌ Inserisci l'URL iCal di Airbnb.");return;}
    setIcalStatus("⏳ Sincronizzazione in corso...");
    try {
      const res = await fetch("/api/fetch-ical", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ url: icalUrl.trim() }),
      });
      if(!res.ok){const d=await res.json().catch(()=>({}));throw new Error(d.error||"HTTP "+res.status);}
      const text = await res.text();
      const events = parseIcal(text);
      if(!events.length){setIcalStatus("⚠️ Nessuna prenotazione trovata nel calendario.");return;}
      const existing = blockedDates[prop.id]||[];
      const merged = [...existing];
      let added = 0;
      for(const ev of events){
        const dup = merged.find(b=>b.from===ev.from&&b.to===ev.to);
        if(!dup){merged.push(ev);added++;}
      }
      const updated = {...blockedDates,[prop.id]:merged};
      setBlockedDates(updated); LS.set("rls_blocked",updated); dbSave({blockedDates:updated});
      f("icalUrl", icalUrl.trim());
      setIcalStatus(`✅ Sincronizzato! ${added} nuove prenotazioni importate (${events.length} totali nel calendario).`);
    } catch(e) {
      setIcalStatus("❌ Errore: "+e.message+". Controlla l'URL iCal.");
    }
  }

  return (
    <div style={{display:"grid",gap:16}}>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
        <div><label className="lbl">Titolo</label><input className="inp" value={form.titleIt} onChange={e=>f("titleIt",e.target.value)}/></div>
        <div><label className="lbl">Sottotitolo</label><input className="inp" value={form.subtitleIt||""} onChange={e=>f("subtitleIt",e.target.value)}/></div>
        <div><label className="lbl">Prezzo/notte (€)</label><input className="inp" type="number" value={form.price} onChange={e=>f("price",+e.target.value)}/></div>
        <div><label className="lbl">Pulizie (€)</label><input className="inp" type="number" value={form.cleaning} onChange={e=>f("cleaning",+e.target.value)}/></div>
        <div><label className="lbl">Max ospiti</label><input className="inp" type="number" value={form.maxG} onChange={e=>f("maxG",+e.target.value)}/></div>
        <div><label className="lbl">Notti minime</label><input className="inp" type="number" value={form.minN} onChange={e=>f("minN",+e.target.value)}/></div>
        <div><label className="lbl">Check-in</label><input className="inp" value={form.ci} onChange={e=>f("ci",e.target.value)}/></div>
        <div><label className="lbl">Check-out</label><input className="inp" value={form.co} onChange={e=>f("co",e.target.value)}/></div>
      </div>
      {/* Prezzi per date */}
      <div>
        <label className="lbl">Prezzi per periodo (sovrascrivono il prezzo base)</label>
        <div style={{display:"flex",flexDirection:"column",gap:8,marginBottom:8}}>
          {(form.priceRules||[]).map((rule,i)=>(
            <div key={rule.id||i} style={{display:"grid",gridTemplateColumns:"1fr 120px 120px 80px 32px",gap:8,alignItems:"center",background:"#f5f0eb",padding:"8px 10px",borderRadius:2}}>
              <input className="inp" placeholder="Etichetta (es. Alta stagione)" value={rule.label||""} onChange={e=>{const r=[...(form.priceRules||[])];r[i]={...r[i],label:e.target.value};f("priceRules",r);}} style={{fontSize:12}}/>
              <input className="inp" type="date" value={rule.from||""} onChange={e=>{const r=[...(form.priceRules||[])];r[i]={...r[i],from:e.target.value};f("priceRules",r);}} style={{fontSize:12}}/>
              <input className="inp" type="date" value={rule.to||""} onChange={e=>{const r=[...(form.priceRules||[])];r[i]={...r[i],to:e.target.value};f("priceRules",r);}} style={{fontSize:12}}/>
              <input className="inp" type="number" placeholder="€/notte" value={rule.price||""} onChange={e=>{const r=[...(form.priceRules||[])];r[i]={...r[i],price:+e.target.value};f("priceRules",r);}} style={{fontSize:12}}/>
              <button className="btn-danger" onClick={()=>{const r=(form.priceRules||[]).filter((_,j)=>j!==i);f("priceRules",r);}} style={{padding:"6px 8px",fontSize:12}}>✕</button>
            </div>
          ))}
        </div>
        <button className="btn-o" style={{fontSize:11}} onClick={()=>f("priceRules",[...(form.priceRules||[]),{id:"pr"+Date.now(),label:"",from:"",to:"",price:prop?.price||0}])}>+ Aggiungi periodo</button>
      </div>
      <div><label className="lbl">Descrizione</label><textarea className="inp" rows={5} value={form.descIt||""} onChange={e=>f("descIt",e.target.value)}/></div>

      {/* Regole */}
      <div>
        <label className="lbl">Regole (una per riga)</label>
        <textarea className="inp" rows={3} value={(form.rules||[]).join("\n")} onChange={e=>f("rules",e.target.value.split("\n").filter(r=>r.trim()))}/>
      </div>

      {/* Cover */}
      <div>
        <label className="lbl">Foto copertina</label>
        <div style={{display:"flex",alignItems:"center",gap:12,flexWrap:"wrap"}}>
          {form.cover
            ?<img src={form.cover} alt="" style={{width:100,height:70,objectFit:"cover",borderRadius:2}}/>
            :<div style={{width:100,height:70,background:"#eee",display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,color:"#999",borderRadius:2}}>Nessuna</div>}
          <ImgUploader label="Carica copertina" onUpload={src=>f("cover",src)}/>
          {form.cover&&<button className="btn-danger" style={{fontSize:11}} onClick={()=>f("cover","")}>✕ Rimuovi</button>}
        </div>
      </div>

      {/* Gallery */}
      <div>
        <label className="lbl">Galleria foto ({(form.images||[]).length} caricate)</label>
        <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:8}}>
          {(form.images||[]).map((src,i)=>(
            <div key={i} style={{position:"relative"}}>
              <img src={src} alt="" style={{width:80,height:55,objectFit:"cover",borderRadius:2}}/>
              <button onClick={()=>f("images",(form.images||[]).filter((_,j)=>j!==i))} style={{position:"absolute",top:-6,right:-6,background:"#dc2626",color:"#fff",border:"none",borderRadius:"50%",width:18,height:18,fontSize:11,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center"}}>✕</button>
            </div>
          ))}
        </div>
        <ImgUploader label="Aggiungi foto galleria" multiple onUpload={srcs=>f("images",[...(form.images||[]),...srcs])}/>
      </div>

      {/* Sync Airbnb iCal */}
      <div style={{background:"#f5f0eb",padding:16,borderRadius:2}}>
        <label className="lbl" style={{marginBottom:8}}>🔗 Sincronizza disponibilità da Airbnb (iCal)</label>
        <p style={{fontSize:11,color:"#79716c",marginBottom:10}}>Trova l'URL iCal nel tuo pannello Airbnb → Calendario → Sincronizza calendari → Esporta calendario</p>
        <div style={{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap"}}>
          <input className="inp" style={{flex:1,minWidth:200}} value={icalUrl} onChange={e=>setIcalUrl(e.target.value)} placeholder="https://www.airbnb.it/calendar/ical/XXXXXXXX.ics?s=..."/>
          <button className="btn-d" style={{fontSize:11,whiteSpace:"nowrap"}} onClick={syncIcal}>↻ Sincronizza</button>
        </div>
        {icalStatus&&<div style={{marginTop:8,fontSize:12,color:"#1a1816"}}>{icalStatus}</div>}
      </div>

      {/* Date bloccate */}
      <div>
        <label className="lbl">Date bloccate manualmente</label>
        {blocked.length>0&&(
          <div style={{marginBottom:8,display:"flex",flexDirection:"column",gap:4}}>
            {blocked.map((r,i)=>(
              <div key={i} style={{display:"flex",alignItems:"center",gap:8,fontSize:12}}>
                <span style={{background:"#fee2e2",padding:"2px 8px",borderRadius:2}}>{r.from} → {r.to}</span>
                <button onClick={()=>removeBlocked(i)} style={{background:"none",border:"none",color:"#dc2626",cursor:"pointer",fontSize:12}}>✕</button>
              </div>
            ))}
          </div>
        )}
        <div style={{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap"}}>
          <input type="date" className="inp" style={{width:150}} value={newBlFrom} onChange={e=>setNewBlFrom(e.target.value)}/>
          <span style={{fontSize:12}}>→</span>
          <input type="date" className="inp" style={{width:150}} value={newBlTo} onChange={e=>setNewBlTo(e.target.value)}/>
          <button className="btn-o" style={{fontSize:11}} onClick={addBlocked}>+ Blocca</button>
        </div>
      </div>

      <div style={{display:"flex",gap:10}}>
        <button className="btn-d" onClick={()=>onSave(form)}>✓ Salva modifiche</button>
        <button className="btn-o" onClick={onCancel}>Annulla</button>
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// ADMIN — Reviews Manager
// ─────────────────────────────────────────────────────────────────────────────
function ReviewsManager({reviews,setReviews,props,dbSave}) {
  const [filter,setFilter] = useState("pending"); // "pending" | "approved" | "all"
  const [editing,setEditing] = useState(null);

  function allReviews() {
    return Object.entries(reviews).flatMap(([propId,arr])=>arr.map(r=>({...r,propId})));
  }

  function filtered() {
    const all=allReviews();
    if(filter==="pending") return all.filter(r=>r.approved===false);
    if(filter==="approved") return all.filter(r=>r.approved!==false);
    return all;
  }

  function approve(r) {
    const updated={...reviews,[r.propId]:(reviews[r.propId]||[]).map(x=>x.id===r.id?{...x,approved:true}:x)};
    setReviews(updated); LS.set("rls_reviews",updated); dbSave({reviews:updated});
  }
  function remove(r) {
    const updated={...reviews,[r.propId]:(reviews[r.propId]||[]).filter(x=>x.id!==r.id)};
    setReviews(updated); LS.set("rls_reviews",updated); dbSave({reviews:updated});
  }
  function saveEdit(r) {
    const updated={...reviews,[r.propId]:(reviews[r.propId]||[]).map(x=>x.id===r.id?{...r}:x)};
    setReviews(updated); LS.set("rls_reviews",updated); dbSave({reviews:updated});
    setEditing(null);
  }

  const list=filtered();
  const pendingCount=allReviews().filter(r=>r.approved===false).length;

  return (
    <div>
      {/* Tabs */}
      <div style={{display:"flex",gap:4,marginBottom:20,borderBottom:"1px solid #eee"}}>
        {[
          {key:"pending",label:`In attesa${pendingCount>0?` (${pendingCount})`:""}`,color:"#92400e"},
          {key:"approved",label:"Approvate",color:"#15803d"},
          {key:"all",label:"Tutte"},
        ].map(t=>(
          <button key={t.key} className={`tab ${filter===t.key?"active":""}`} onClick={()=>setFilter(t.key)} style={{color:filter===t.key&&t.color?t.color:undefined}}>{t.label}</button>
        ))}
      </div>

      {list.length===0&&<div style={{textAlign:"center",padding:40,color:"#79716c",fontSize:13}}>Nessuna recensione in questa categoria.</div>}

      <div style={{display:"grid",gap:12}}>
        {list.map(r=>{
          const propName=props.find(p=>p.id===r.propId)?.titleIt||r.propId;
          if(editing?.id===r.id) return (
            <div key={r.id} style={{border:"2px solid #c49535",padding:20,background:"#fff"}}>
              <div style={{display:"grid",gap:10}}>
                <div><label className="lbl">Nome</label><input className="inp" value={editing.name} onChange={e=>setEditing({...editing,name:e.target.value})}/></div>
                <div><label className="lbl">Data</label><input className="inp" value={editing.date} onChange={e=>setEditing({...editing,date:e.target.value})}/></div>
                <div><label className="lbl">Valutazione</label><Stars value={editing.rating} onChange={v=>setEditing({...editing,rating:v})}/></div>
                <div><label className="lbl">Testo</label><textarea className="inp" rows={3} value={editing.text} onChange={e=>setEditing({...editing,text:e.target.value})}/></div>
                <div style={{display:"flex",gap:8}}>
                  <button className="btn-d" style={{fontSize:11}} onClick={()=>saveEdit(editing)}>✓ Salva</button>
                  <button className="btn-o" style={{fontSize:11}} onClick={()=>setEditing(null)}>Annulla</button>
                </div>
              </div>
            </div>
          );
          return (
            <div key={r.id} style={{border:"1px solid #eee",padding:16,background:"#fff",display:"flex",gap:12,alignItems:"flex-start",flexWrap:"wrap"}}>
              <div style={{flex:1,minWidth:220}}>
                <div style={{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap",marginBottom:6}}>
                  <span style={{fontWeight:500,fontSize:13}}>{r.country} {r.name}</span>
                  <Stars value={r.rating}/>
                  <span style={{fontSize:11,color:"#79716c"}}>{r.date}</span>
                  <span style={{fontSize:10,background:"#f5f0eb",padding:"2px 6px",borderRadius:1}}>{propName}</span>
                  {r.approved===false
                    ?<span style={{fontSize:10,background:"#fef9c3",color:"#92400e",padding:"2px 6px",borderRadius:1}}>⏳ In attesa</span>
                    :<span style={{fontSize:10,background:"#dcfce7",color:"#15803d",padding:"2px 6px",borderRadius:1}}>✓ Approvata</span>}
                </div>
                <p style={{fontSize:12,lineHeight:1.6,color:"#3a3530"}}>{r.text}</p>
              </div>
              <div style={{display:"flex",gap:6,flexShrink:0,flexWrap:"wrap"}}>
                {r.approved===false&&<button className="btn-d" style={{fontSize:10,padding:"6px 12px",background:"#15803d"}} onClick={()=>approve(r)}>✓ Approva</button>}
                <button className="btn-o" style={{fontSize:10,padding:"6px 12px"}} onClick={()=>setEditing({...r})}>✏️ Modifica</button>
                <button className="btn-danger" style={{fontSize:10,padding:"6px 12px"}} onClick={()=>remove(r)}>✕ Elimina</button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// ADMIN — Site Settings (homepage + contatti)
// ─────────────────────────────────────────────────────────────────────────────
function SiteSettings({site,setSite,dbSave}) {
  const [form,setForm] = useState({...site});
  const [saved,setSaved] = useState(false);
  function f(k,v){setForm(p=>({...p,[k]:v}));}
  function save() { setSite(form); LS.set("rls_site",form); dbSave({site:form}); setSaved(true); setTimeout(()=>setSaved(false),2500); }

  return (
    <div style={{display:"grid",gap:24}}>
      {saved&&<div style={{background:"#dcfce7",color:"#15803d",padding:"10px 14px",fontSize:13,borderRadius:2}}>✓ Impostazioni salvate!</div>}

      {/* Hero */}
      <div style={{border:"1px solid #eee",padding:20,background:"#fff"}}>
        <div className="sl" style={{marginBottom:12}}>Homepage · Hero</div>
        <div style={{display:"grid",gap:12}}>
          <div><label className="lbl">Tagline (sopra il titolo)</label><input className="inp" value={form.heroTagline||""} onChange={e=>f("heroTagline",e.target.value)}/></div>
          <div><label className="lbl">Titolo principale</label><textarea className="inp" rows={2} value={form.heroTitle||""} onChange={e=>f("heroTitle",e.target.value)}/></div>
          <div><label className="lbl">Sottotitolo / descrizione</label><textarea className="inp" rows={3} value={form.heroSubtitle||""} onChange={e=>f("heroSubtitle",e.target.value)}/></div>
        </div>
      </div>

      {/* Features bar */}
      <div style={{border:"1px solid #eee",padding:20,background:"#fff"}}>
        <div className="sl" style={{marginBottom:12}}>Homepage · Barra caratteristiche (4 elementi)</div>
        <div style={{display:"grid",gap:10}}>
          {(form.features||[]).map((feat,i)=>(
            <div key={i} style={{display:"grid",gridTemplateColumns:"60px 1fr",gap:8}}>
              <div><label className="lbl">Icona</label><input className="inp" value={feat.icon} onChange={e=>f("features",form.features.map((x,j)=>j===i?{...x,icon:e.target.value}:x))}/></div>
              <div><label className="lbl">Testo</label><input className="inp" value={feat.text} onChange={e=>f("features",form.features.map((x,j)=>j===i?{...x,text:e.target.value}:x))}/></div>
            </div>
          ))}
        </div>
      </div>

      {/* Contatti */}
      <div style={{border:"1px solid #eee",padding:20,background:"#fff"}}>
        <div className="sl" style={{marginBottom:12}}>Informazioni di Contatto</div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
          <div><label className="lbl">Email</label><input className="inp" type="email" value={form.contactEmail||""} onChange={e=>f("contactEmail",e.target.value)} placeholder="tua@email.com"/></div>
          <div><label className="lbl">Telefono / WhatsApp</label><input className="inp" value={form.contactPhone||""} onChange={e=>f("contactPhone",e.target.value)} placeholder="+39 333 000 0000"/></div>
          <div><label className="lbl">WhatsApp link</label><input className="inp" value={form.contactWhatsapp||""} onChange={e=>f("contactWhatsapp",e.target.value)} placeholder="https://wa.me/39333000000"/></div>
          <div><label className="lbl">Instagram</label><input className="inp" value={form.contactInstagram||""} onChange={e=>f("contactInstagram",e.target.value)} placeholder="@relaxluxurystays"/></div>
          <div><label className="lbl">Facebook</label><input className="inp" value={form.contactFacebook||""} onChange={e=>f("contactFacebook",e.target.value)} placeholder="facebook.com/relaxluxurystays"/></div>
        </div>
      </div>

      {/* Footer */}
      <div style={{border:"1px solid #eee",padding:20,background:"#fff"}}>
        <div className="sl" style={{marginBottom:12}}>Footer</div>
        <div><label className="lbl">Testo footer</label><input className="inp" value={form.footerText||""} onChange={e=>f("footerText",e.target.value)}/></div>
      </div>

      <button className="btn-d" style={{alignSelf:"flex-start"}} onClick={save}>✓ Salva tutte le impostazioni</button>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// ADMIN DASHBOARD
// ─────────────────────────────────────────────────────────────────────────────
function Admin({props,setProps,blockedDates,setBlockedDates,reviews,setReviews,site,setSite,session,onLogout,onExit,dbSave}) {
  const [tab,setTab] = useState("props"); // "props" | "reviews" | "site" | "users"
  const [editing,setEditing] = useState(null);

  const pendingCount=Object.values(reviews).flat().filter(r=>r.approved===false).length;

  function saveEdit(updated) {
    const newProps=props.map(p=>p.id===updated.id?updated:p);
    setProps(newProps); LS.set("rls_props",newProps);
    dbSave({props:newProps});
    setEditing(null);
  }

  return (
    <div style={{minHeight:"100vh",background:"#fafaf8"}}>
      {/* Admin top bar */}
      <div style={{background:"#1a1816",color:"#f5f0eb",padding:"0 24px",height:54,display:"flex",alignItems:"center",justifyContent:"space-between"}}>
        <div style={{display:"flex",alignItems:"center",gap:16}}>
          <span className="df" style={{fontSize:18,color:"#c49535"}}>RelaxLuxuryStays</span>
          <span style={{fontSize:11,color:"rgba(245,240,235,.4)",letterSpacing:".1em",textTransform:"uppercase"}}>Admin</span>
        </div>
        <div style={{display:"flex",alignItems:"center",gap:16}}>
          <span style={{fontSize:12,color:"rgba(245,240,235,.6)"}}>👤 {session?.name||session?.email}</span>
          <button className="btn-o" style={{fontSize:10,padding:"5px 12px",color:"#f5f0eb",borderColor:"rgba(245,240,235,.2)"}} onClick={onExit}>← Sito</button>
          <button className="btn-o" style={{fontSize:10,padding:"5px 12px",color:"#f5f0eb",borderColor:"rgba(245,240,235,.2)"}} onClick={onLogout}>Esci</button>
        </div>
      </div>

      <div style={{maxWidth:960,margin:"0 auto",padding:"28px 20px"}}>
        {/* Page tabs */}
        <div style={{display:"flex",gap:4,borderBottom:"1px solid #eee",marginBottom:28}}>
          {[
            {key:"props",label:"🏠 Proprietà"},
            {key:"reviews",label:`💬 Recensioni${pendingCount>0?` (${pendingCount})`:""}`,},
            {key:"site",label:"⚙️ Sito & Contatti"},
          ].map(t=>(
            <button key={t.key} className={`tab ${tab===t.key?"active":""}`} onClick={()=>{setTab(t.key);setEditing(null);}}
              style={{fontSize:12,color:tab===t.key&&t.key==="reviews"&&pendingCount>0?"#92400e":undefined}}>{t.label}</button>
          ))}
        </div>

        {/* PROPERTIES TAB */}
        {tab==="props" && !editing && (
          <div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:24}}>
              {[
                {label:"Proprietà",value:props.length,icon:"🏠"},
                {label:"Con foto",value:props.filter(p=>p.cover).length,icon:"📸"},
                {label:"Senza foto",value:props.filter(p=>!p.cover).length,icon:"📷"},
                {label:"Recensioni",value:Object.values(reviews).flat().filter(r=>r.approved!==false).length,icon:"★"},
              ].map(s=>(
                <div key={s.label} style={{padding:16,background:"#fff",border:"1px solid #eee",textAlign:"center"}}>
                  <div style={{fontSize:20}}>{s.icon}</div>
                  <div style={{fontSize:22,fontWeight:600,margin:"4px 0"}}>{s.value}</div>
                  <div style={{fontSize:11,color:"#79716c"}}>{s.label}</div>
                </div>
              ))}
            </div>
            <div style={{display:"grid",gap:14}}>
              {props.map(p=>(
                <div key={p.id} style={{background:"#fff",border:"1px solid #eee",padding:18,display:"flex",gap:14,alignItems:"flex-start",flexWrap:"wrap"}}>
                  <img src={p.cover||PLACEHOLDER} alt={p.titleIt} style={{width:88,height:62,objectFit:"cover",borderRadius:2,flexShrink:0}}/>
                  <div style={{flex:1,minWidth:180}}>
                    <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:4,flexWrap:"wrap"}}>
                      <span className="sl">{TYPE_LABEL[p.type]} · {p.city}</span>
                      {(p.cover||(p.images&&p.images.length>0))
                        ?<span style={{fontSize:10,background:"#dcfce7",color:"#15803d",padding:"2px 8px",borderRadius:1}}>✓ Foto OK ({(p.images||[]).length+1})</span>
                        :<span style={{fontSize:10,background:"#fef9c3",color:"#92400e",padding:"2px 8px",borderRadius:1}}>📷 Foto mancanti</span>}
                    </div>
                    <div style={{fontSize:14,fontWeight:500,marginBottom:4}}>{p.titleIt}</div>
                    <div style={{fontSize:12,color:"#79716c"}}>€{p.price}/notte · {p.beds} letti · max {p.maxG} ospiti · min {p.minN} notti</div>
                    <div style={{fontSize:11,color:"#b0a898",marginTop:4}}>
                      ID: {p.airbnbId} · <a href={p.airbnbUrl} target="_blank" rel="noreferrer" style={{color:"#c49535"}}>Vedi Airbnb</a>
                    </div>
                  </div>
                  <button className="btn-d" style={{fontSize:11,flexShrink:0}} onClick={()=>setEditing(p)}>✏️ Modifica</button>
                </div>
              ))}
            </div>
          </div>
        )}
        {tab==="props" && editing && (
          <div>
            <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:20}}>
              <button className="btn-o" style={{fontSize:11}} onClick={()=>setEditing(null)}>← Torna</button>
              <span style={{fontSize:14,fontWeight:500}}>Modifica: {editing.titleIt}</span>
            </div>
            <PropForm prop={editing} onSave={saveEdit} onCancel={()=>setEditing(null)} blockedDates={blockedDates} setBlockedDates={setBlockedDates} dbSave={dbSave}/>
          </div>
        )}

        {/* REVIEWS TAB */}
        {tab==="reviews" && <ReviewsManager reviews={reviews} setReviews={setReviews} props={props} dbSave={dbSave}/>}

        {/* SITE SETTINGS TAB */}
        {tab==="site" && <SiteSettings site={site} setSite={setSite} dbSave={dbSave}/>}
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// BOOKING FORM
// ─────────────────────────────────────────────────────────────────────────────
function BookingForm({prop,checkIn,checkOut,site,lang="it"}) {
  const [form,setForm] = useState({name:"",email:"",phone:"",guests:1,message:""});
  const [status,setStatus] = useState("");
  const {subtotal,nights}=checkIn&&checkOut?calcStayPrice(checkIn,checkOut,prop):{subtotal:0,nights:0};
  const total=nights>0?subtotal+prop.cleaning:0;
  function f(k,v){setForm(p=>({...p,[k]:v}));}

  async function send(e) {
    e.preventDefault();
    if(!form.name||!form.email) return;
    setStatus("sending");
    try {
      await sendEmail({
        to_name:"Vittorio", to_email:site?.contactEmail||"ugozunardi@gmail.com",
        from_name:form.name, from_email:form.email, phone:form.phone||"—",
        property:prop.titleIt, checkin:checkIn?fmtDate(checkIn):"—", checkout:checkOut?fmtDate(checkOut):"—",
        nights, guests:form.guests, total, message:form.message||"—"
      });
      setStatus("ok");
    } catch{setStatus("err");}
  }

  return (
    <form onSubmit={send} style={{display:"grid",gap:12}}>
      {status==="ok"&&<div style={{background:"#dcfce7",color:"#15803d",padding:"12px 16px",fontSize:13,borderRadius:2}}>{T[lang].book_ok}</div>}
      {status==="err"&&<div style={{background:"#fee2e2",color:"#dc2626",padding:"12px 16px",fontSize:13,borderRadius:2}}>{T[lang].book_err}</div>}
      <div className="book-form-grid" style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
        <div><label className="lbl">{T[lang].book_name}</label><input className="inp" required value={form.name} onChange={e=>f("name",e.target.value)} placeholder={T[lang].book_name_ph}/></div>
        <div><label className="lbl">{T[lang].book_email}</label><input className="inp" required type="email" value={form.email} onChange={e=>f("email",e.target.value)} placeholder={T[lang].book_email_ph}/></div>
        <div><label className="lbl">{T[lang].book_phone}</label><input className="inp" value={form.phone} onChange={e=>f("phone",e.target.value)} placeholder="+39 333 123 4567"/></div>
        <div><label className="lbl">{T[lang].book_guests}</label>
          <select className="inp" value={form.guests} onChange={e=>f("guests",+e.target.value)}>
            {Array.from({length:prop.maxG},(_,i)=>i+1).map(n=><option key={n} value={n}>{n} {T[lang].guests}</option>)}
          </select>
        </div>
      </div>
      <div><label className="lbl">{T[lang].book_msg}</label><textarea className="inp" rows={3} value={form.message} onChange={e=>f("message",e.target.value)} placeholder={T[lang].book_msg_ph}/></div>
      {nights>0&&<div style={{fontSize:12,color:"#79716c",padding:"8px 12px",background:"#f5f0eb"}}>📅 {fmtDate(checkIn)} → {fmtDate(checkOut)} · {nights} {nights===1?T[lang].night:T[lang].nights} · <strong>€{total} {T[lang].total.toLowerCase()}</strong></div>}
      <button className="btn-d" type="submit" disabled={status==="sending"} style={{opacity:status==="sending"?.6:1}}>
        {status==="sending"?T[lang].book_sending:T[lang].book_send}
      </button>
      <p style={{fontSize:11,color:"#79716c",textAlign:"center"}}>{T[lang].book_guarantee}</p>
    </form>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// PROPERTY CARD
// ─────────────────────────────────────────────────────────────────────────────
function Card({prop,onClick,reviews,lang="it"}) {
  const img=prop.cover||PLACEHOLDER;
  const propReviews=(reviews[prop.id]||[]).filter(r=>r.approved!==false);
  const avg=propReviews.length?(propReviews.reduce((s,r)=>s+r.rating,0)/propReviews.length).toFixed(1):null;
  const displayTitle=prop.titleIt; // always keep property name in Italian for SEO
  const typeLabel={HOUSE:T[lang].type_house,VILLA:T[lang].type_villa,APARTMENT:T[lang].type_apartment}[prop.type];
  return (
    <div className="fu" style={{cursor:"pointer",background:"#fff",border:"1px solid #eee",overflow:"hidden",transition:"box-shadow .2s"}}
      onMouseEnter={e=>e.currentTarget.style.boxShadow="0 8px 32px rgba(0,0,0,.1)"}
      onMouseLeave={e=>e.currentTarget.style.boxShadow="none"}
      onClick={onClick}>
      <div style={{position:"relative",height:260,overflow:"hidden"}}>
        <img src={img} alt={displayTitle} style={{width:"100%",height:"100%",objectFit:"cover",transition:"transform .4s"}}
          onMouseEnter={e=>e.target.style.transform="scale(1.04)"} onMouseLeave={e=>e.target.style.transform="scale(1)"}/>
        <span style={{position:"absolute",top:12,left:12,background:"rgba(26,24,22,.7)",color:"#c49535",padding:"4px 10px",fontSize:10,fontWeight:500,letterSpacing:".15em",textTransform:"uppercase",backdropFilter:"blur(4px)"}}>
          {typeLabel}
        </span>
        {(prop.airbnbRating||avg)&&<span style={{position:"absolute",top:12,right:12,background:"rgba(26,24,22,.7)",color:"#fff",padding:"4px 10px",fontSize:12,backdropFilter:"blur(4px)"}}>★ {prop.airbnbRating||avg}</span>}
      </div>
      <div style={{padding:"18px 20px 20px"}}>
        <div className="sl" style={{marginBottom:4}}>{prop.city} · {prop.region}</div>
        <h3 className="df" style={{fontSize:18,fontWeight:400,marginBottom:8,lineHeight:1.3}}>{displayTitle}</h3>
        <div style={{display:"flex",gap:16,fontSize:12,color:"#79716c",marginBottom:14}}>
          <span>👤 max {prop.maxG}</span><span>🛏 {prop.beds} {T[lang].beds}</span><span>🚿 {prop.bath} {T[lang].bath}</span>
        </div>
        <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:16}}>
          {prop.amenities.slice(0,4).map(a=>{const am=AMENITY_MAP[a];const lbl=lang==="es"?(am?.labelEs||am?.label):lang==="fr"?(am?.labelFr||am?.label):lang==="en"?(am?.labelEn||am?.label):am?.label;return<span key={a} style={{fontSize:11,background:"#f5f0eb",padding:"3px 8px",borderRadius:1}}>{am?.icon} {lbl}</span>;})}
        </div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          {SHOW_PRICES&&<div><span style={{fontSize:11,color:"#79716c"}}>{(prop.priceRules&&prop.priceRules.length>0)?"da ":""}</span><span style={{fontWeight:600,fontSize:18}}>€{prop.price}</span><span style={{fontSize:12,color:"#79716c"}}>{T[lang].per_night}</span></div>}
          <span style={{fontSize:11,color:"#c49535",fontWeight:500}}>{T[lang].explore}</span>
        </div>
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// PROPERTY DETAIL
// ─────────────────────────────────────────────────────────────────────────────
function HouseRulesSection({prop,lang}) {
  const [open,setOpen] = useState(false);
  const rules = lang==="es"&&prop.rulesEs?.length ? prop.rulesEs : lang==="fr"&&prop.rulesFr?.length ? prop.rulesFr : lang==="en"&&prop.rulesEn?.length ? prop.rulesEn : prop.rules||[];
  function ruleIcon(r) {
    const s=r.toLowerCase();
    if(s.includes("fum")||s.includes("smok")) return "🚭";
    if(s.includes("fest")||s.includes("event")||s.includes("part")) return "🎉";
    if(s.includes("anim")||s.includes("pet")) return "🐾";
    if(s.includes("max")||s.includes("ospiti")||s.includes("guest")) return "👥";
    if(s.includes("silenz")||s.includes("quiet")||s.includes("rumore")) return "🔇";
    return "✓";
  }
  return (
    <>
      <div style={{border:"1px solid #e8e4e0",borderRadius:12,padding:24,marginBottom:32}}>
        <div style={{display:"flex",gap:16,alignItems:"flex-start"}}>
          <span style={{fontSize:26,lineHeight:1}}>🔑</span>
          <div style={{flex:1}}>
            <div style={{fontWeight:600,fontSize:16,marginBottom:10}}>{T[lang].rules_title}</div>
            <div style={{fontSize:13,color:"#79716c",lineHeight:2}}>
              <div>Check-in: {prop.ci}</div>
              <div>Check-out: {prop.co}</div>
              {rules.slice(0,2).map((r,i)=><div key={i}>{r}</div>)}
            </div>
            <button onClick={()=>setOpen(true)} style={{background:"none",border:"none",cursor:"pointer",fontSize:13,color:"#1a1816",textDecoration:"underline",padding:0,marginTop:10,fontFamily:"'Jost',sans-serif",fontWeight:500}}>
              {T[lang].rules_more}
            </button>
          </div>
        </div>
      </div>
      {open&&createPortal(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.5)",zIndex:9999,display:"flex",alignItems:"center",justifyContent:"center",padding:20}} onClick={()=>setOpen(false)}>
          <div style={{background:"#fff",borderRadius:12,padding:40,maxWidth:580,width:"100%",maxHeight:"85vh",overflowY:"auto"}} onClick={e=>e.stopPropagation()}>
            <button onClick={()=>setOpen(false)} style={{background:"none",border:"none",fontSize:20,cursor:"pointer",float:"right",lineHeight:1,padding:0,color:"#1a1816"}}>✕</button>
            <h2 style={{fontSize:22,fontWeight:600,marginBottom:8,fontFamily:"'Cormorant Garamond',serif"}}>{T[lang].rules_title}</h2>
            <p style={{fontSize:13,color:"#79716c",marginBottom:28,lineHeight:1.6}}>{T[lang].rules_subtitle}</p>
            <h3 style={{fontSize:14,fontWeight:600,marginBottom:16}}>{T[lang].rules_ci}</h3>
            {[["🕐",`Check-in: ${prop.ci}`],["🕐",`Check-out: ${prop.co}`]].map(([icon,txt],i)=>(
              <div key={i} style={{display:"flex",alignItems:"center",gap:14,padding:"14px 0",borderBottom:"1px solid #f0ece8",fontSize:13}}><span style={{fontSize:18}}>{icon}</span>{txt}</div>
            ))}
            <h3 style={{fontSize:14,fontWeight:600,marginTop:28,marginBottom:16}}>{T[lang].rules_during}</h3>
            {rules.map((r,i)=>(
              <div key={i} style={{display:"flex",alignItems:"center",gap:14,padding:"14px 0",borderBottom:"1px solid #f0ece8",fontSize:13}}>
                <span style={{fontSize:18}}>{ruleIcon(r)}</span>{r}
              </div>
            ))}
          </div>
        </div>,
        document.body
      )}
    </>
  );
}

function PropDetail({prop,onBack,blockedDates,reviews,setReviews,site,lang="it"}) {
  const [lightbox,setLightbox] = useState(null);
  const [checkIn,setCheckIn] = useState(null);
  const [checkOut,setCheckOut] = useState(null);
  const allImages=[prop.cover,...(prop.images||[]).filter(img=>img!==prop.cover)].filter(Boolean);
  const displayImages=allImages.length>0?allImages:[PLACEHOLDER,PLACEHOLDER,PLACEHOLDER,PLACEHOLDER,PLACEHOLDER];
  const propTitle=prop.titleIt; // always keep property name in Italian for SEO
  const propSubtitle=lang==="es"?(prop.subtitleEs||prop.subtitleEn||prop.subtitleIt):lang==="fr"?(prop.subtitleFr||prop.subtitleEn||prop.subtitleIt):lang==="en"?(prop.subtitleEn||prop.subtitleIt):prop.subtitleIt;
  const propDesc=lang==="es"?(prop.descEs||prop.descEn||prop.descIt):lang==="fr"?(prop.descFr||prop.descEn||prop.descIt):lang==="en"?(prop.descEn||prop.descIt):prop.descIt;

  // Dynamic title & meta per questa proprietà
  useEffect(()=>{
    document.title = prop.titleIt + " — Relax Luxury Stays";
    const m=document.querySelector('meta[name="description"]');
    if(m) m.setAttribute("content", prop.subtitleIt+". "+prop.city+", "+prop.region+", Sicilia. A partire da €"+prop.price+"/notte. Superhost Airbnb certificato.");
    return ()=>{
      document.title="Relax Luxury Stays — Agrigento, Scala dei Turchi, Sicilia";
      if(m) m.setAttribute("content","Relax Luxury Stays: 4 proprietà esclusive ad Agrigento e Scala dei Turchi, Sicilia. Superhost Airbnb certificato con 50+ recensioni ★★★★★.");
    };
  },[prop]);

  // JSON-LD schema per questa proprietà
  const propReviews=(reviews[prop.id]||[]).filter(r=>r.approved!==false);
  const avgRating=propReviews.length?(propReviews.reduce((s,r)=>s+r.rating,0)/propReviews.length).toFixed(1):null;
  const schema={
    "@context":"https://schema.org","@type":"LodgingBusiness",
    "name":prop.titleIt,"description":prop.subtitleIt,
    "address":{"@type":"PostalAddress","addressLocality":prop.city,"addressRegion":prop.region,"addressCountry":"IT"},
    "priceRange":"A partire da €"+prop.price+"/notte",
    "url":prop.airbnbUrl,
    ...(avgRating&&propReviews.length?{"aggregateRating":{"@type":"AggregateRating","ratingValue":avgRating,"bestRating":"5","reviewCount":propReviews.length}}:{}),
  };

  return (
    <>
    <script type="application/ld+json" dangerouslySetInnerHTML={{__html:JSON.stringify(schema)}}/>
    <div className="fu">
      <button className="btn-o" onClick={onBack} style={{margin:"20px 0 16px",display:"flex",alignItems:"center",gap:6,fontSize:11}}>{T[lang].back}</button>
      {/* Gallery */}
      <div style={{position:"relative",marginBottom:28}}>
        <div className="gallery-main" style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr",gridTemplateRows:"260px 260px",gap:3,borderRadius:8,overflow:"hidden",height:523}}>
          <div style={{gridRow:"1/3",gridColumn:"1/2",cursor:"pointer",overflow:"hidden"}} onClick={()=>setLightbox(0)}>
            <img src={displayImages[0]} alt={prop.titleIt} style={{width:"100%",height:"100%",objectFit:"cover",transition:"transform .4s"}} onMouseEnter={e=>e.target.style.transform="scale(1.03)"} onMouseLeave={e=>e.target.style.transform="scale(1)"}/>
          </div>
          {displayImages.slice(1,5).map((src,i)=>(
            <div key={i} style={{overflow:"hidden",cursor:"pointer",position:"relative"}} onClick={()=>setLightbox(i+1)}>
              <img src={src} alt="" style={{width:"100%",height:"100%",objectFit:"cover",transition:"transform .4s"}} onMouseEnter={e=>e.target.style.transform="scale(1.05)"} onMouseLeave={e=>e.target.style.transform="scale(1)"}/>
            </div>
          ))}
        </div>
        <button onClick={()=>setLightbox(0)}
          style={{position:"absolute",bottom:12,right:12,background:"rgba(255,255,255,.95)",border:"1px solid rgba(0,0,0,.18)",padding:"7px 14px",fontSize:12,fontWeight:500,cursor:"pointer",borderRadius:6,backdropFilter:"blur(4px)",display:"flex",alignItems:"center",gap:7,fontFamily:"'Jost',sans-serif",boxShadow:"0 1px 4px rgba(0,0,0,.12)"}}>
          <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="1" y="1" width="5" height="5"/><rect x="10" y="1" width="5" height="5"/><rect x="1" y="10" width="5" height="5"/><rect x="10" y="10" width="5" height="5"/></svg>
          {T[lang].show_photos} ({allImages.length})
        </button>
      </div>
      {/* Layout */}
      <div className="detail-layout" style={{display:"grid",gridTemplateColumns:"1fr 380px",gap:40,alignItems:"start"}}>
        <div className="detail-main">
          <div className="sl" style={{marginBottom:8}}>{prop.city} · {prop.region} · {{HOUSE:T[lang].type_house,VILLA:T[lang].type_villa,APARTMENT:T[lang].type_apartment}[prop.type]}</div>
          <h1 className="df" style={{fontSize:32,fontWeight:400,lineHeight:1.2,marginBottom:8}}>{propTitle}</h1>
          <p style={{fontSize:13,color:"#79716c",marginBottom:24}}>{propSubtitle}</p>
          <div className="detail-stats" style={{display:"flex",gap:24,padding:"16px 0",borderTop:"1px solid #eee",borderBottom:"1px solid #eee",marginBottom:24,flexWrap:"wrap"}}>
            {[{icon:"👤",text:`Max ${prop.maxG} ${T[lang].stat_guests}`},{icon:"🛏",text:`${prop.bed} ${T[lang].rooms} · ${prop.beds} ${T[lang].beds}`},{icon:"🚿",text:`${prop.bath} ${T[lang].bath}`},{icon:"🕐",text:`${T[lang].ci_abbr} ${prop.ci} / ${T[lang].co_abbr} ${prop.co}`},{icon:"🌙",text:`Min ${prop.minN} ${T[lang].nights}`}].map(x=>(
              <div key={x.text} style={{textAlign:"center"}}><div style={{fontSize:18}}>{x.icon}</div><div style={{fontSize:11,color:"#79716c",marginTop:4}}>{x.text}</div></div>
            ))}
          </div>
          <div style={{marginBottom:32}}>
            <div className="sl" style={{marginBottom:12}}>{T[lang].prop_section}</div>
            {(propDesc||"").split("\n\n").map((para,i)=><p key={i} style={{fontSize:14,lineHeight:1.75,color:"#3a3530",marginBottom:12}}>{para}</p>)}
          </div>
          <div style={{marginBottom:32}}>
            <div className="sl" style={{marginBottom:12}}>{T[lang].amenities_title}</div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(160px,1fr))",gap:10}}>
              {prop.amenities.map(a=>(
                <div key={a} style={{display:"flex",alignItems:"center",gap:8,padding:"10px 12px",background:"#f5f0eb"}}>
                  <span style={{fontSize:18}}>{AMENITY_MAP[a]?.icon}</span><span style={{fontSize:12}}>{lang==="es"?(AMENITY_MAP[a]?.labelEs||AMENITY_MAP[a]?.label):lang==="fr"?(AMENITY_MAP[a]?.labelFr||AMENITY_MAP[a]?.label):lang==="en"?(AMENITY_MAP[a]?.labelEn||AMENITY_MAP[a]?.label):AMENITY_MAP[a]?.label}</span>
                </div>
              ))}
            </div>
          </div>
          {prop.lat&&prop.lng&&(
            <div style={{marginBottom:32}}>
              <div className="sl" style={{marginBottom:6}}>{T[lang].where_title}</div>
              <div style={{fontSize:13,color:"#79716c",marginBottom:12}}>{prop.city}, {prop.region}, {prop.country}</div>
              <div style={{borderRadius:12,overflow:"hidden",border:"1px solid #e8e4e0",marginBottom:12}}>
                <iframe
                  title="map"
                  src={`https://www.openstreetmap.org/export/embed.html?bbox=${prop.lng-0.018},${prop.lat-0.012},${prop.lng+0.018},${prop.lat+0.012}&layer=mapnik&marker=${prop.lat},${prop.lng}`}
                  style={{width:"100%",height:380,border:"none",display:"block"}}
                  loading="lazy"
                  sandbox="allow-scripts allow-same-origin"
                />
              </div>
              <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:8}}>
                <span style={{fontSize:13,color:"#79716c"}}>{T[lang].where_verified}</span>
                <a href={`https://maps.google.com/?q=${prop.lat},${prop.lng}`} target="_blank" rel="noreferrer"
                  style={{fontSize:12,color:"#c49535",textDecoration:"underline",fontWeight:500}}>
                  🗺 {T[lang].where_open}
                </a>
              </div>
            </div>
          )}
          <ReviewSection propId={prop.id} reviews={reviews} setReviews={setReviews} prop={prop} lang={lang}/>
          {prop.rules&&prop.rules.length>0&&<HouseRulesSection prop={prop} lang={lang}/>}
        </div>
        <div className="detail-sidebar" style={{position:"sticky",top:20,maxHeight:"calc(100vh - 40px)",overflowY:"auto"}}>
          <div style={{border:"1px solid #e8e4e0",padding:24,background:"#fff"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"baseline",marginBottom:16}}>
              {SHOW_PRICES&&<div><span style={{fontSize:22,fontWeight:600}}>€{prop.price}</span><span style={{fontSize:13,color:"#79716c"}}> {T[lang].per_night}</span></div>}
              {(prop.airbnbRating||null)&&<span style={{fontSize:13}}>★ {prop.airbnbRating} · <span style={{color:"#79716c"}}>{prop.airbnbReviews} {T[lang].reviews_short}</span></span>}
            </div>
            <div style={{marginBottom:16}}>
              <AvailCalendar propId={prop.id} blockedDates={blockedDates} minN={prop.minN||1}
                onRangeChange={(ci,co)=>{setCheckIn(ci);setCheckOut(co);}} lang={lang} prop={prop}/>
            </div>
            <PriceBreakdown prop={prop} checkIn={checkIn} checkOut={checkOut} lang={lang}/>
            <div style={{marginTop:16}}>
              <div className="sl" style={{marginBottom:12}}>{T[lang].book_title}</div>
              <BookingForm prop={prop} checkIn={checkIn} checkOut={checkOut} site={site} lang={lang}/>
            </div>
          </div>
          <div style={{marginTop:16,border:"1px solid #e8e4e0",padding:20,background:"#fff",display:"flex",alignItems:"center",gap:16}}>
            <div style={{width:52,height:52,borderRadius:"50%",background:"#c49535",display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontSize:20,fontWeight:600,flexShrink:0}}>V</div>
            <div>
              <div style={{fontWeight:500,fontSize:14}}>Vittorio · Superhost 🏆</div>
              <div style={{fontSize:11,color:"#79716c",marginTop:2}}>Agrigento, Sicilia · {T[lang].host_since}</div>
              {site?.contactPhone&&<div style={{fontSize:11,color:"#c49535",marginTop:4}}>📞 {site.contactPhone}</div>}
            </div>
          </div>
        </div>
      </div>
      {lightbox!==null&&createPortal(<Lightbox images={displayImages} startIdx={lightbox} onClose={()=>setLightbox(null)}/>,document.body)}
    </div>
    </>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// HOME
// ─────────────────────────────────────────────────────────────────────────────
function Home({props,onSelect,site,reviews,lang="it"}) {
  const [filter,setFilter] = useState("ALL");
  const [search,setSearch] = useState("");
  const filtered=props.filter(p=>{
    const matchType=filter==="ALL"||p.type===filter;
    const titleToSearch=lang==="en"?(p.titleEn||p.titleIt):p.titleIt;
    const matchSearch=!search||titleToSearch.toLowerCase().includes(search.toLowerCase())||p.city.toLowerCase().includes(search.toLowerCase());
    return matchType&&matchSearch;
  });

  const heroLines=(site.heroTitle||"Relax Luxury\nStays").split("\n");

  return (
    <div>
      {/* Hero */}
      <div style={{background:"linear-gradient(135deg,#1a1816 0%,#2d2926 60%,#1a1816 100%)",padding:"60px 20px",textAlign:"center",position:"relative",overflow:"hidden"}}>
        <div style={{width:60,height:1,background:"#c49535",margin:"0 auto 24px"}}/>
        <div className="sl" style={{color:"#c49535",marginBottom:12}}>{T[lang].hero_tagline||site.heroTagline||""}</div>
        <h1 className="df" style={{color:"#f5f0eb",fontSize:"clamp(32px,6vw,64px)",fontWeight:400,lineHeight:1.15,marginBottom:16}}>
          {heroLines[0]}<br/><em>{heroLines[1]||""}</em>
        </h1>
        <p style={{color:"rgba(245,240,235,.6)",fontSize:14,maxWidth:480,margin:"0 auto 32px",lineHeight:1.7}}>{T[lang].hero_subtitle||site.heroSubtitle||""}</p>
        <div className="hero-btns" style={{display:"flex",gap:12,justifyContent:"center",flexWrap:"wrap"}}>
          <button className="btn-d" style={{background:"#c49535",color:"#1a1816"}} onClick={()=>document.getElementById("props")?.scrollIntoView({behavior:"smooth"})}>{T[lang].discover}</button>
          {site.contactWhatsapp&&<a href={site.contactWhatsapp} target="_blank" rel="noreferrer" className="btn-d" style={{background:"#25D366",color:"#fff",textDecoration:"none"}}>💬 WhatsApp</a>}
        </div>
        <div style={{width:60,height:1,background:"#c49535",margin:"32px auto 0"}}/>
      </div>

      {/* Features bar */}
      <div style={{background:"#fff",borderBottom:"1px solid #eee",padding:"16px 24px",overflow:"hidden"}}>
        <div className="features-bar" style={{maxWidth:900,margin:"0 auto",display:"flex",gap:32,justifyContent:"center",flexWrap:"wrap"}}>
          {(T[lang].features||site.features||[]).map(f=>(
            <div key={f.text} style={{display:"flex",alignItems:"center",gap:8,fontSize:12,color:"#79716c"}}>
              <span style={{color:"#c49535"}}>{f.icon}</span>{f.text}
            </div>
          ))}
        </div>
      </div>

      {/* Search & filter */}
      <div id="props" style={{maxWidth:960,margin:"32px auto 16px",padding:"0 16px",display:"flex",gap:10,flexWrap:"wrap",alignItems:"center"}}>
        <input className="inp" style={{flex:1,minWidth:200}} placeholder={T[lang].search_ph} value={search} onChange={e=>setSearch(e.target.value)}/>
        <div className="filter-btns" style={{display:"flex",gap:10}}>
          {["ALL","HOUSE","VILLA","APARTMENT"].map(t=>(
            <button key={t} onClick={()=>setFilter(t)} className={filter===t?"btn-d":"btn-o"} style={{fontSize:11}}>
              {t==="ALL"?T[lang].filter_all:{HOUSE:T[lang].filter_house,VILLA:T[lang].filter_villa,APARTMENT:T[lang].filter_apartment}[t]}
            </button>
          ))}
        </div>
      </div>

      {/* Grid */}
      <div style={{maxWidth:960,margin:"0 auto",padding:"0 20px 60px"}}>
        {filtered.length===0
          ?<div style={{textAlign:"center",padding:60,color:"#79716c",fontSize:14}}>{T[lang].no_results} <button style={{background:"none",border:"none",color:"#c49535",cursor:"pointer",fontSize:14}} onClick={()=>{setFilter("ALL");setSearch("");}}>{T[lang].remove_filters}</button></div>
          :<div className="prop-grid" style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:24}}>
            {filtered.map(p=><Card key={p.id} prop={p} onClick={()=>onSelect(p)} reviews={reviews} lang={lang}/>)}
          </div>}
      </div>

      {/* Why direct */}
      <div style={{background:"#1a1816",padding:"60px 24px",textAlign:"center"}}>
        <div style={{width:40,height:1,background:"#c49535",margin:"0 auto 20px"}}/>
        <div className="sl" style={{color:"#c49535",marginBottom:8}}>{T[lang].why_title}</div>
        <h2 className="df" style={{color:"#f5f0eb",fontSize:28,marginBottom:32,fontWeight:400}}>{T[lang].why_sub}</h2>
        <div className="why-grid" style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:24,maxWidth:900,margin:"0 auto"}}>
          {T[lang].why_items.map(v=>(
            <div key={v.title} style={{padding:20,border:"1px solid rgba(255,255,255,.1)"}}>
              <div style={{fontSize:28,marginBottom:8}}>{v.icon}</div>
              <div style={{color:"#f5f0eb",fontWeight:500,fontSize:14,marginBottom:4}}>{v.title}</div>
              <div style={{color:"rgba(245,240,235,.5)",fontSize:12,lineHeight:1.5}}>{v.desc}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Contacts section */}
      {(site.contactEmail||site.contactPhone||site.contactWhatsapp||site.contactInstagram) && (
        <div style={{background:"#f5f0eb",padding:"48px 24px",textAlign:"center"}}>
          <div className="sl" style={{marginBottom:8}}>Contatti</div>
          <h2 className="df" style={{fontSize:26,marginBottom:24,fontWeight:400}}>{T[lang].contact_title}</h2>
          <div style={{display:"flex",gap:16,justifyContent:"center",flexWrap:"wrap"}}>
            {site.contactEmail&&<a href={`mailto:${site.contactEmail}`} className="btn-d" style={{textDecoration:"none"}}>✉️ {site.contactEmail}</a>}
            {site.contactWhatsapp&&<a href={site.contactWhatsapp} target="_blank" rel="noreferrer" className="btn-d" style={{background:"#25D366",textDecoration:"none"}}>💬 WhatsApp</a>}
            {site.contactPhone&&<a href={`tel:${site.contactPhone.replace(/\s/g,"")}`} className="btn-o" style={{textDecoration:"none"}}>📞 {site.contactPhone}</a>}
            {site.contactInstagram&&<a href={`https://instagram.com/${site.contactInstagram.replace("@","")}`} target="_blank" rel="noreferrer" className="btn-o" style={{textDecoration:"none"}}>📸 {site.contactInstagram}</a>}
          </div>
        </div>
      )}
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// ROOT APP
// ─────────────────────────────────────────────────────────────────────────────
export default function App() {
  const [props,setProps] = useState(()=>{
    const cached=LS.get("rls_props",null);
    if(!cached) return PROPS_DEFAULT;
    return cached.map(p=>{
      const def=PROPS_DEFAULT.find(d=>d.id===p.id)||{};
      const di=def.images||[];
      const extras=(p.images||[]).filter(i=>!di.includes(i));
      return {...p,
        cover: def.cover || p.cover || "",
        images: di.length>0?[...di,...extras]:(p.images||[]),
      };
    });
  });
  const [blockedDates,setBlockedDates] = useState(()=>LS.get("rls_blocked",{}));
  const [reviews,setReviews] = useState(()=>LS.get("rls_reviews",REVIEWS_DEFAULT));
  const [site,setSite] = useState(()=>LS.get("rls_site",SITE_DEFAULT));
  const [session,setSession] = useState(()=>getSession());
  const [lang,setLangState] = useState(()=>LS.get("rls_lang","it"));
  function setLang(l){setLangState(l);LS.set("rls_lang",l);}
  const [page,setPage] = useState("home"); // "home"|"detail"|"admin"|"auth"
  const [selectedProp,setSelectedProp] = useState(null);
  const [menuOpen,setMenuOpen] = useState(false); // eslint-disable-line no-unused-vars
  const [dbLoading,setDbLoading] = useState(JSONBIN_CONFIGURED);
  const propsRef = useRef(null);
  propsRef.current = props;
  const urlNavigated = useRef(false);

  useEffect(()=>{
    const style=document.createElement("style");
    style.textContent=CSS;
    document.head.appendChild(style);
    return ()=>document.head.removeChild(style);
  },[]);

  // URL routing — navigate to property when DB finishes loading
  useEffect(()=>{
    if(dbLoading||urlNavigated.current) return;
    urlNavigated.current=true;
    const path=window.location.pathname.slice(1);
    if(path){
      const found=propsRef.current.find(p=>toSlug(p.titleIt)===path);
      if(found){setSelectedProp(found);setPage("detail");}
    }
  },[dbLoading]); // eslint-disable-line react-hooks/exhaustive-deps

  // Dynamic SEO: update document title and meta description on page change
  useEffect(()=>{
    const siteName = "Relax Luxury Stays";
    if(page==="detail"&&selectedProp){
      const title = lang==="en"
        ? `${selectedProp.titleEn||selectedProp.titleIt} — Luxury Stay in Agrigento, Sicily | ${siteName}`
        : `${selectedProp.titleIt} — Agrigento, Sicilia | ${siteName}`;
      const desc = lang==="en"
        ? `${selectedProp.subtitleEn||selectedProp.subtitleIt}. Book directly with Vittorio, Airbnb Superhost with 437+ reviews ★★★★★.`
        : `${selectedProp.subtitleIt}. Prenota direttamente con Vittorio, Superhost Airbnb con 437+ recensioni ★★★★★.`;
      document.title = title;
      let metaDesc = document.querySelector('meta[name="description"]');
      if(metaDesc) metaDesc.setAttribute("content", desc);
    } else if(page==="home"){
      document.title = lang==="en"
        ? `${siteName} — Luxury Apartments in Agrigento, Sicily`
        : `${siteName} — Appartamenti di lusso ad Agrigento, Scala dei Turchi, Sicilia`;
      let metaDesc = document.querySelector('meta[name="description"]');
      if(metaDesc) metaDesc.setAttribute("content", lang==="en"
        ? "Relax Luxury Stays: luxury apartments and villas in Agrigento and Scala dei Turchi, Sicily. Rosemary, Sage, Scala dei Turchi, Campagna with private pool. Certified Airbnb Superhost · 437 reviews · 4.81★. Book directly and save."
        : "Relax Luxury Stays: appartamenti e ville di lusso ad Agrigento e Scala dei Turchi, Sicilia. Rosemary, Sage, Scala dei Turchi, Casa in Campagna con piscina. Superhost Airbnb certificato · 437 recensioni · 4,81★. Prenota direttamente e risparmia.");
    }
  },[page,selectedProp,lang]);

  // Browser back/forward support
  useEffect(()=>{
    const onPop=()=>{
      const path=window.location.pathname.slice(1);
      window.scrollTo(0,0);
      if(!path){setPage("home");setSelectedProp(null);}
      else{
        const found=propsRef.current.find(p=>toSlug(p.titleIt)===path);
        if(found){setSelectedProp(found);setPage("detail");}
        else{setPage("home");setSelectedProp(null);window.history.replaceState({},'','/');}
      }
    };
    window.addEventListener('popstate',onPop);
    return()=>window.removeEventListener('popstate',onPop);
  },[]); // eslint-disable-line react-hooks/exhaustive-deps

  // Load shared data from jsonblob on first visit
  useEffect(()=>{
    if(!JSONBIN_CONFIGURED){return;}
    jbRead().then(data=>{
      if(data){
        if(data.props&&Array.isArray(data.props)&&data.props.length>0){
          // Merge DB props with defaults: preserve default images if DB has none
          const defOrder=PROPS_DEFAULT.map(d=>d.id);
          let needsWrite=false;
          const merged=data.props
            .map(dbP=>{
              const def=PROPS_DEFAULT.find(d=>d.id===dbP.id)||{};
              const icalUrl = dbP.icalUrl || def.icalUrl || "";
              if(!dbP.icalUrl && icalUrl) needsWrite=true;
              return {
                ...dbP,
                cover: def.cover || dbP.cover || "",
                images: (()=>{const di=def.images||[];const extras=(dbP.images||[]).filter(i=>!di.includes(i));return di.length>0?[...di,...extras]:(dbP.images||[]);})(),
                icalUrl,
                titleEn: dbP.titleEn || def.titleEn || "",
                subtitleEn: dbP.subtitleEn || def.subtitleEn || "",
                descEn: dbP.descEn || def.descEn || "",
                rulesEn: dbP.rulesEn || def.rulesEn || [],
                subtitleEs: dbP.subtitleEs || def.subtitleEs || "",
                descEs: dbP.descEs || def.descEs || "",
                rulesEs: dbP.rulesEs || def.rulesEs || [],
                subtitleFr: dbP.subtitleFr || def.subtitleFr || "",
                descFr: dbP.descFr || def.descFr || "",
                rulesFr: dbP.rulesFr || def.rulesFr || [],
                priceRules: dbP.priceRules || def.priceRules || [],
                airbnbRating: dbP.airbnbRating || def.airbnbRating || null,
                airbnbReviews: dbP.airbnbReviews || def.airbnbReviews || 0,
                airbnbSubRatings: dbP.airbnbSubRatings || def.airbnbSubRatings || null,
                lat: dbP.lat || def.lat || null,
                lng: dbP.lng || def.lng || null,
              };
            })
            .sort((a,b)=>{
              const ai=defOrder.indexOf(a.id); const bi=defOrder.indexOf(b.id);
              return (ai===-1?999:ai)-(bi===-1?999:bi);
            });
          setProps(merged);LS.set("rls_props",merged);
          // Write back to DB if any icalUrl was added from PROPS_DEFAULT
          if(needsWrite) jbWrite({props:merged,reviews:data.reviews||{},site:data.site||{},blockedDates:data.blockedDates||{}});
        }
        if(data.reviews){
          // Merge DB reviews with REVIEWS_DEFAULT:
          // - For default reviews (matching ID): use REVIEWS_DEFAULT as source of truth for content, keep DB's approved status
          // - Add any default reviews missing from DB (new ones added in code)
          // - Keep user-submitted reviews (IDs starting with "u") as-is
          const mergedRevs={};
          for(const propId of Object.keys({...data.reviews,...REVIEWS_DEFAULT})){
            const dbArr=data.reviews[propId]||[];
            const defArr=REVIEWS_DEFAULT[propId]||[];
            // Start with all default reviews (authoritative content)
            const result=defArr.map(def=>{
              const dbR=dbArr.find(r=>r.id===def.id);
              // Use default content but preserve admin's approved decision if explicitly set to false
              return {...def, approved: dbR&&dbR.approved===false ? false : true};
            });
            // Append user-submitted reviews (id starts with "u") not in defaults
            for(const r of dbArr){
              if(r.id.startsWith("u")&&!result.find(x=>x.id===r.id)) result.push(r);
            }
            mergedRevs[propId]=result;
          }
          setReviews(mergedRevs);LS.set("rls_reviews",mergedRevs);
        }
        if(data.site){
          // Merge DB site with defaults: DB wins except for empty strings (fall back to default)
          const mergedSite={...SITE_DEFAULT};
          for(const [k,v] of Object.entries(data.site)){
            if(v!==null&&v!==undefined&&v!=="") mergedSite[k]=v;
          }
          setSite(mergedSite);LS.set("rls_site",mergedSite);
        }
        if(data.blockedDates&&Object.keys(data.blockedDates).length>0){setBlockedDates(data.blockedDates);LS.set("rls_blocked",data.blockedDates);}
      }
      setDbLoading(false);
    }).catch(()=>setDbLoading(false));
  },[]); // eslint-disable-line react-hooks/exhaustive-deps

  // dbSave: called explicitly by admin components after every save
  function dbSave(patch){
    const merged={
      props:   patch.props   ?? props,
      reviews: patch.reviews ?? reviews,
      site:    patch.site    ?? site,
      blockedDates: patch.blockedDates ?? blockedDates,
    };
    jbWrite(merged).then(()=>{
      // Show toast on success (check console for errors if not visible)
      const t=document.createElement("div");
      t.textContent="✓ Salvato nel database";
      t.style.cssText="position:fixed;bottom:24px;right:24px;background:#1a1816;color:#f5f0eb;padding:10px 18px;font-family:Jost,sans-serif;font-size:12px;z-index:9999;border-left:3px solid #c49535;";
      document.body.appendChild(t);
      setTimeout(()=>t.remove(),3000);
    });
  }

  function selectProp(p){setSelectedProp(p);setPage("detail");window.scrollTo(0,0);setMenuOpen(false);window.history.pushState({},'','/'+toSlug(p.titleIt));}
  function goHome(){setPage("home");setSelectedProp(null);window.scrollTo(0,0);window.history.pushState({},'','/');}
  function goAdmin(){if(session){setPage("admin");}else{setPage("auth");}window.scrollTo(0,0);setMenuOpen(false);}
  function onAuthSuccess(user){setSession(user);setPage("admin");window.scrollTo(0,0);}
  function onLogout(){clearSession();setSession(null);setPage("home");}

  const currentProp=selectedProp?props.find(p=>p.id===selectedProp.id)||selectedProp:null;

  if(dbLoading) return (
    <div style={{minHeight:"100vh",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",background:"#fafaf8",gap:16}}>
      <div style={{width:40,height:40,border:"3px solid #e8e4e0",borderTopColor:"#c49535",borderRadius:"50%",animation:"spin 0.8s linear infinite"}}/>
      <span className="sl">Caricamento…</span>
    </div>
  );

  if(page==="auth") return <AuthScreen onSuccess={onAuthSuccess} onBack={goHome}/>;
  if(page==="admin") return (
    <Admin props={props} setProps={setProps} blockedDates={blockedDates} setBlockedDates={setBlockedDates}
      reviews={reviews} setReviews={setReviews} site={site} setSite={setSite}
      session={session} onLogout={onLogout} onExit={goHome} dbSave={dbSave}/>
  );

  return (
    <div style={{minHeight:"100vh"}}>
      {/* NAV */}
      <nav style={{position:"sticky",top:0,zIndex:100,background:"rgba(250,250,248,.95)",backdropFilter:"blur(12px)",borderBottom:"1px solid #e8e4e0",padding:"0 24px",display:"flex",alignItems:"center",justifyContent:"space-between",height:60}}>
        <button onClick={goHome} style={{background:"none",border:"none",cursor:"pointer",display:"flex",alignItems:"center",gap:10}}>
          <img src="/logo.svg" alt="Relax Luxury Stays" style={{width:42,height:42,borderRadius:8,border:"1px solid #c49535"}} />
          <span className="df nav-logo-text" style={{fontSize:18,fontWeight:400}}>RelaxLuxuryStays</span>
        </button>
        <div className="nav-right" style={{display:"flex",gap:20,alignItems:"center"}}>
          <button className="nav-text-link" onClick={goHome} style={{background:"none",border:"none",cursor:"pointer",fontSize:11,color:"#1a1816",letterSpacing:".1em",textTransform:"uppercase",fontFamily:"'Jost',sans-serif",fontWeight:500}}>{T[lang].nav_props}</button>
          <a className="nav-text-link" href={`mailto:${site.contactEmail||"ugozunardi@gmail.com"}`} style={{textDecoration:"none",fontSize:11,color:"#1a1816",letterSpacing:".1em",textTransform:"uppercase",fontFamily:"'Jost',sans-serif",fontWeight:500}}>{T[lang].nav_contacts}</a>
          {site.contactWhatsapp&&<a href={site.contactWhatsapp} target="_blank" rel="noreferrer" style={{textDecoration:"none",fontSize:11,color:"#25D366",letterSpacing:".1em",textTransform:"uppercase",fontFamily:"'Jost',sans-serif",fontWeight:500}}>💬</a>}
          <div className="lang-sel" style={{display:"flex",gap:4,alignItems:"center",background:"#f5f0eb",borderRadius:20,padding:"3px 6px"}}>
            {["it","en","es","fr"].map(l=>(
              <button key={l} onClick={()=>setLang(l)}
                style={{background:"none",border:"none",cursor:"pointer",fontSize:18,lineHeight:1,padding:"2px 4px",borderRadius:14,opacity:lang===l?1:.35,transform:lang===l?"scale(1.15)":"scale(1)",transition:"all .15s",outline:"none"}}>
                {l==="it"?"🇮🇹":l==="en"?"🇬🇧":l==="es"?"🇪🇸":"🇫🇷"}
              </button>
            ))}
          </div>
          <button className="btn-d" onClick={goAdmin} style={{fontSize:10,padding:"7px 14px"}}>
            {session?`👤 ${session.name||"Admin"}`:"Admin"}
          </button>
        </div>
      </nav>

      <main className="main-wrap">
        {page==="home"&&<Home props={props} onSelect={selectProp} site={site} reviews={reviews} lang={lang}/>}
        {page==="detail"&&currentProp&&(
          <div style={{padding:"0 20px"}}>
            <PropDetail prop={currentProp} onBack={goHome} blockedDates={blockedDates} reviews={reviews} setReviews={setReviews} site={site} lang={lang}/>
          </div>
        )}
      </main>

      {/* FOOTER */}
      <footer style={{background:"#1a1816",color:"rgba(245,240,235,.5)",padding:"32px 24px",textAlign:"center",fontSize:12}}>
        <div className="df" style={{color:"#c49535",fontSize:18,marginBottom:8}}>RelaxLuxuryStays</div>
        <div style={{marginBottom:8}}>{site.footerText||"Agrigento · Valle dei Templi · Sicilia, Italia"}</div>
        <div style={{marginBottom:8}}>
          {site.contactEmail&&<a href={`mailto:${site.contactEmail}`} style={{color:"rgba(245,240,235,.5)",textDecoration:"none",marginRight:16}}>{site.contactEmail}</a>}
          {site.contactInstagram&&<a href={`https://instagram.com/${site.contactInstagram.replace("@","")}`} target="_blank" rel="noreferrer" style={{color:"rgba(245,240,235,.5)",textDecoration:"none"}}>{site.contactInstagram}</a>}
        </div>
        <div style={{fontSize:11,opacity:.5,marginTop:12}}>{T[lang].footer_copy}</div>
      </footer>

      {/* WhatsApp floating button */}
      {site.contactWhatsapp&&(
        <a href={site.contactWhatsapp} target="_blank" rel="noreferrer"
          style={{position:"fixed",bottom:20,right:16,zIndex:9000,width:56,height:56,borderRadius:"50%",background:"#25D366",color:"#fff",display:"flex",alignItems:"center",justifyContent:"center",boxShadow:"0 4px 16px rgba(37,211,102,.45)",textDecoration:"none",transition:"transform .18s"}}
          onMouseEnter={e=>e.currentTarget.style.transform="scale(1.08)"}
          onMouseLeave={e=>e.currentTarget.style.transform="scale(1)"}
          title="Chatta su WhatsApp">
          <svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
          </svg>
        </a>
      )}
    </div>
  );
}
